var obj = {
  //国家列表
  countryList: [
    { value: "", label: " " },
    { value: "AF", label: "Afghanistan", is_region_visible: true },
    {
      value: "AX",
      label: "\u00c5land Islands",
      is_region_visible: true,
    },
    { value: "AL", label: "Albania", is_region_visible: true },
    { value: "DZ", label: "Algeria", is_region_visible: true },
    { value: "AS", label: "American Samoa", is_region_visible: true },
    { value: "AD", label: "Andorra", is_region_visible: true },
    { value: "AO", label: "Angola", is_region_visible: true },
    { value: "AI", label: "Anguilla", is_region_visible: true },
    { value: "AQ", label: "Antarctica", is_region_visible: true },
    {
      value: "AG",
      label: "Antigua & Barbuda",
      is_region_visible: true,
    },
    { value: "AR", label: "Argentina", is_region_visible: true },
    { value: "AM", label: "Armenia", is_region_visible: true },
    { value: "AW", label: "Aruba", is_region_visible: true },
    { value: "AU", label: "Australia", is_region_visible: true },
    { value: "AT", label: "Austria", is_region_visible: true },
    { value: "AZ", label: "Azerbaijan", is_region_visible: true },
    { value: "BS", label: "Bahamas", is_region_visible: true },
    { value: "BH", label: "Bahrain", is_region_visible: true },
    { value: "BD", label: "Bangladesh", is_region_visible: true },
    { value: "BB", label: "Barbados", is_region_visible: true },
    { value: "BY", label: "Belarus", is_region_visible: true },
    { value: "BE", label: "Belgium", is_region_visible: true },
    { value: "BZ", label: "Belize", is_region_visible: true },
    { value: "BJ", label: "Benin", is_region_visible: true },
    { value: "BM", label: "Bermuda", is_region_visible: true },
    { value: "BT", label: "Bhutan", is_region_visible: true },
    { value: "BO", label: "Bolivia", is_region_visible: true },
    {
      value: "BA",
      label: "Bosnia & Herzegovina",
      is_region_visible: true,
    },
    { value: "BW", label: "Botswana", is_region_visible: true },
    { value: "BV", label: "Bouvet Island", is_region_visible: true },
    { value: "BR", label: "Brazil", is_region_visible: true },
    {
      value: "IO",
      label: "British Indian Ocean Territory",
      is_region_visible: true,
    },
    {
      value: "VG",
      label: "British Virgin Islands",
      is_region_visible: true,
    },
    { value: "BN", label: "Brunei", is_region_visible: true },
    { value: "BG", label: "Bulgaria", is_region_visible: true },
    { value: "BF", label: "Burkina Faso", is_region_visible: true },
    { value: "BI", label: "Burundi", is_region_visible: true },
    { value: "KH", label: "Cambodia", is_region_visible: true },
    { value: "CM", label: "Cameroon", is_region_visible: true },
    { value: "CA", label: "Canada", is_region_visible: true },
    { value: "CV", label: "Cape Verde", is_region_visible: true },
    {
      value: "BQ",
      label: "Caribbean Netherlands",
      is_region_visible: true,
    },
    { value: "KY", label: "Cayman Islands", is_region_visible: true },
    {
      value: "CF",
      label: "Central African Republic",
      is_region_visible: true,
    },
    { value: "TD", label: "Chad", is_region_visible: true },
    { value: "CL", label: "Chile", is_region_visible: true },
    { value: "CN", label: "China", is_region_visible: true },
    {
      value: "CX",
      label: "Christmas Island",
      is_region_visible: true,
    },
    {
      value: "CC",
      label: "Cocos (Keeling) Islands",
      is_region_visible: true,
    },
    { value: "CO", label: "Colombia", is_region_visible: true },
    { value: "KM", label: "Comoros", is_region_visible: true },
    {
      value: "CG",
      label: "Congo - Brazzaville",
      is_region_visible: true,
    },
    {
      value: "CD",
      label: "Congo - Kinshasa",
      is_region_visible: true,
    },
    { value: "CK", label: "Cook Islands", is_region_visible: true },
    { value: "CR", label: "Costa Rica", is_region_visible: true },
    {
      value: "CI",
      label: "C\u00f4te d\u2019Ivoire",
      is_region_visible: true,
    },
    { value: "HR", label: "Croatia", is_region_visible: true },
    { value: "CU", label: "Cuba", is_region_visible: true },
    { value: "CW", label: "Cura\u00e7ao", is_region_visible: true },
    { value: "CY", label: "Cyprus", is_region_visible: true },
    { value: "CZ", label: "Czechia", is_region_visible: true },
    { value: "DK", label: "Denmark", is_region_visible: true },
    { value: "DJ", label: "Djibouti", is_region_visible: true },
    { value: "DM", label: "Dominica", is_region_visible: true },
    {
      value: "DO",
      label: "Dominican Republic",
      is_region_visible: true,
    },
    { value: "EC", label: "Ecuador", is_region_visible: true },
    { value: "EG", label: "Egypt", is_region_visible: true },
    { value: "SV", label: "El Salvador", is_region_visible: true },
    {
      value: "GQ",
      label: "Equatorial Guinea",
      is_region_visible: true,
    },
    { value: "ER", label: "Eritrea", is_region_visible: true },
    { value: "EE", label: "Estonia", is_region_visible: true },
    { value: "SZ", label: "Eswatini", is_region_visible: true },
    { value: "ET", label: "Ethiopia", is_region_visible: true },
    {
      value: "FK",
      label: "Falkland Islands",
      is_region_visible: true,
    },
    { value: "FO", label: "Faroe Islands", is_region_visible: true },
    { value: "FJ", label: "Fiji", is_region_visible: true },
    { value: "FI", label: "Finland", is_region_visible: true },
    { value: "FR", label: "France", is_region_visible: true },
    { value: "GF", label: "French Guiana", is_region_visible: true },
    {
      value: "PF",
      label: "French Polynesia",
      is_region_visible: true,
    },
    {
      value: "TF",
      label: "French Southern Territories",
      is_region_visible: true,
    },
    { value: "GA", label: "Gabon", is_region_visible: true },
    { value: "GM", label: "Gambia", is_region_visible: true },
    { value: "GE", label: "Georgia", is_region_visible: true },
    { value: "DE", label: "Germany", is_region_visible: true },
    { value: "GH", label: "Ghana", is_region_visible: true },
    { value: "GI", label: "Gibraltar", is_region_visible: true },
    { value: "GR", label: "Greece", is_region_visible: true },
    { value: "GL", label: "Greenland", is_region_visible: true },
    { value: "GD", label: "Grenada", is_region_visible: true },
    { value: "GP", label: "Guadeloupe", is_region_visible: true },
    { value: "GU", label: "Guam", is_region_visible: true },
    { value: "GT", label: "Guatemala", is_region_visible: true },
    { value: "GG", label: "Guernsey", is_region_visible: true },
    { value: "GN", label: "Guinea", is_region_visible: true },
    { value: "GW", label: "Guinea-Bissau", is_region_visible: true },
    { value: "GY", label: "Guyana", is_region_visible: true },
    { value: "HT", label: "Haiti", is_region_visible: true },
    {
      value: "HM",
      label: "Heard & McDonald Islands",
      is_region_visible: true,
    },
    { value: "HN", label: "Honduras", is_region_visible: true },
    {
      value: "HK",
      label: "Hong Kong SAR China",
      is_region_visible: true,
    },
    { value: "HU", label: "Hungary", is_region_visible: true },
    { value: "IS", label: "Iceland", is_region_visible: true },
    { value: "IN", label: "India", is_region_visible: true },
    { value: "ID", label: "Indonesia", is_region_visible: true },
    { value: "IR", label: "Iran", is_region_visible: true },
    { value: "IQ", label: "Iraq", is_region_visible: true },
    { value: "IE", label: "Ireland", is_region_visible: true },
    { value: "IM", label: "Isle of Man", is_region_visible: true },
    { value: "IL", label: "Israel", is_region_visible: true },
    { value: "IT", label: "Italy", is_region_visible: true },
    { value: "JM", label: "Jamaica", is_region_visible: true },
    { value: "JP", label: "Japan", is_region_visible: true },
    { value: "JE", label: "Jersey", is_region_visible: true },
    { value: "JO", label: "Jordan", is_region_visible: true },
    { value: "KZ", label: "Kazakhstan", is_region_visible: true },
    { value: "KE", label: "Kenya", is_region_visible: true },
    { value: "KI", label: "Kiribati", is_region_visible: true },
    { value: "XK", label: "Kosovo", is_region_visible: true },
    { value: "KW", label: "Kuwait", is_region_visible: true },
    { value: "KG", label: "Kyrgyzstan", is_region_visible: true },
    { value: "LA", label: "Laos", is_region_visible: true },
    { value: "LV", label: "Latvia", is_region_visible: true },
    { value: "LB", label: "Lebanon", is_region_visible: true },
    { value: "LS", label: "Lesotho", is_region_visible: true },
    { value: "LR", label: "Liberia", is_region_visible: true },
    { value: "LY", label: "Libya", is_region_visible: true },
    { value: "LI", label: "Liechtenstein", is_region_visible: true },
    { value: "LT", label: "Lithuania", is_region_visible: true },
    { value: "LU", label: "Luxembourg", is_region_visible: true },
    {
      value: "MO",
      label: "Macao SAR China",
      is_region_visible: true,
    },
    { value: "MG", label: "Madagascar", is_region_visible: true },
    { value: "MW", label: "Malawi", is_region_visible: true },
    { value: "MY", label: "Malaysia", is_region_visible: true },
    { value: "MV", label: "Maldives", is_region_visible: true },
    { value: "ML", label: "Mali", is_region_visible: true },
    { value: "MT", label: "Malta", is_region_visible: true },
    {
      value: "MH",
      label: "Marshall Islands",
      is_region_visible: true,
    },
    { value: "MQ", label: "Martinique", is_region_visible: true },
    { value: "MR", label: "Mauritania", is_region_visible: true },
    { value: "MU", label: "Mauritius", is_region_visible: true },
    { value: "YT", label: "Mayotte", is_region_visible: true },
    { value: "MX", label: "Mexico", is_region_visible: true },
    { value: "FM", label: "Micronesia", is_region_visible: true },
    { value: "MD", label: "Moldova", is_region_visible: true },
    { value: "MC", label: "Monaco", is_region_visible: true },
    { value: "MN", label: "Mongolia", is_region_visible: true },
    { value: "ME", label: "Montenegro", is_region_visible: true },
    { value: "MS", label: "Montserrat", is_region_visible: true },
    { value: "MA", label: "Morocco", is_region_visible: true },
    { value: "MZ", label: "Mozambique", is_region_visible: true },
    {
      value: "MM",
      label: "Myanmar (Burma)",
      is_region_visible: true,
    },
    { value: "NA", label: "Namibia", is_region_visible: true },
    { value: "NR", label: "Nauru", is_region_visible: true },
    { value: "NP", label: "Nepal", is_region_visible: true },
    { value: "NL", label: "Netherlands", is_region_visible: true },
    { value: "NC", label: "New Caledonia", is_region_visible: true },
    { value: "NZ", label: "New Zealand", is_region_visible: true },
    { value: "NI", label: "Nicaragua", is_region_visible: true },
    { value: "NE", label: "Niger", is_region_visible: true },
    { value: "NG", label: "Nigeria", is_region_visible: true },
    { value: "NU", label: "Niue", is_region_visible: true },
    { value: "NF", label: "Norfolk Island", is_region_visible: true },
    {
      value: "MP",
      label: "Northern Mariana Islands",
      is_region_visible: true,
    },
    { value: "KP", label: "North Korea", is_region_visible: true },
    {
      value: "MK",
      label: "North Macedonia",
      is_region_visible: true,
    },
    { value: "NO", label: "Norway", is_region_visible: true },
    { value: "OM", label: "Oman", is_region_visible: true },
    { value: "PK", label: "Pakistan", is_region_visible: true },
    { value: "PW", label: "Palau", is_region_visible: true },
    {
      value: "PS",
      label: "Palestinian Territories",
      is_region_visible: true,
    },
    { value: "PA", label: "Panama", is_region_visible: true },
    {
      value: "PG",
      label: "Papua New Guinea",
      is_region_visible: true,
    },
    { value: "PY", label: "Paraguay", is_region_visible: true },
    { value: "PE", label: "Peru", is_region_visible: true },
    { value: "PH", label: "Philippines", is_region_visible: true },
    {
      value: "PN",
      label: "Pitcairn Islands",
      is_region_visible: true,
    },
    { value: "PL", label: "Poland", is_region_visible: true },
    { value: "PT", label: "Portugal", is_region_visible: true },
    { value: "PR", label: "Puerto Rico", is_region_visible: true },
    { value: "QA", label: "Qatar", is_region_visible: true },
    { value: "RE", label: "R\u00e9union", is_region_visible: true },
    { value: "RO", label: "Romania", is_region_visible: true },
    { value: "RU", label: "Russia", is_region_visible: true },
    { value: "RW", label: "Rwanda", is_region_visible: true },
    { value: "WS", label: "Samoa", is_region_visible: true },
    { value: "SM", label: "San Marino", is_region_visible: true },
    {
      value: "ST",
      label: "S\u00e3o Tom\u00e9 & Pr\u00edncipe",
      is_region_visible: true,
    },
    { value: "SA", label: "Saudi Arabia", is_region_visible: true },
    { value: "SN", label: "Senegal", is_region_visible: true },
    { value: "RS", label: "Serbia", is_region_visible: true },
    { value: "SC", label: "Seychelles", is_region_visible: true },
    { value: "SL", label: "Sierra Leone", is_region_visible: true },
    { value: "SG", label: "Singapore", is_region_visible: true },
    { value: "SX", label: "Sint Maarten", is_region_visible: true },
    { value: "SK", label: "Slovakia", is_region_visible: true },
    { value: "SI", label: "Slovenia", is_region_visible: true },
    {
      value: "SB",
      label: "Solomon Islands",
      is_region_visible: true,
    },
    { value: "SO", label: "Somalia", is_region_visible: true },
    { value: "ZA", label: "South Africa", is_region_visible: true },
    {
      value: "GS",
      label: "South Georgia & South Sandwich Islands",
      is_region_visible: true,
    },
    { value: "KR", label: "South Korea", is_region_visible: true },
    { value: "ES", label: "Spain", is_region_visible: true },
    { value: "LK", label: "Sri Lanka", is_region_visible: true },
    {
      value: "BL",
      label: "St. Barth\u00e9lemy",
      is_region_visible: true,
    },
    { value: "SH", label: "St. Helena", is_region_visible: true },
    {
      value: "KN",
      label: "St. Kitts & Nevis",
      is_region_visible: true,
    },
    { value: "LC", label: "St. Lucia", is_region_visible: true },
    { value: "MF", label: "St. Martin", is_region_visible: true },
    {
      value: "PM",
      label: "St. Pierre & Miquelon",
      is_region_visible: true,
    },
    {
      value: "VC",
      label: "St. Vincent & Grenadines",
      is_region_visible: true,
    },
    { value: "SD", label: "Sudan", is_region_visible: true },
    { value: "SR", label: "Suriname", is_region_visible: true },
    {
      value: "SJ",
      label: "Svalbard & Jan Mayen",
      is_region_visible: true,
    },
    { value: "SE", label: "Sweden", is_region_visible: true },
    { value: "CH", label: "Switzerland", is_region_visible: true },
    { value: "SY", label: "Syria", is_region_visible: true },
    { value: "TW", label: "Taiwan", is_region_visible: true },
    { value: "TJ", label: "Tajikistan", is_region_visible: true },
    { value: "TZ", label: "Tanzania", is_region_visible: true },
    { value: "TH", label: "Thailand", is_region_visible: true },
    { value: "TL", label: "Timor-Leste", is_region_visible: true },
    { value: "TG", label: "Togo", is_region_visible: true },
    { value: "TK", label: "Tokelau", is_region_visible: true },
    { value: "TO", label: "Tonga", is_region_visible: true },
    {
      value: "TT",
      label: "Trinidad & Tobago",
      is_region_visible: true,
    },
    { value: "TN", label: "Tunisia", is_region_visible: true },
    { value: "TR", label: "T\u00fcrkiye", is_region_visible: true },
    { value: "TM", label: "Turkmenistan", is_region_visible: true },
    {
      value: "TC",
      label: "Turks & Caicos Islands",
      is_region_visible: true,
    },
    { value: "TV", label: "Tuvalu", is_region_visible: true },
    { value: "UG", label: "Uganda", is_region_visible: true },
    { value: "UA", label: "Ukraine", is_region_visible: true },
    {
      value: "AE",
      label: "United Arab Emirates",
      is_region_visible: true,
    },
    { value: "GB", label: "United Kingdom", is_region_visible: true },
    {
      value: "US",
      label: "United States",
      is_region_required: true,
      is_zipcode_optional: true,
      is_default: true,
    },
    { value: "UY", label: "Uruguay", is_region_visible: true },
    {
      value: "UM",
      label: "U.S. Outlying Islands",
      is_region_visible: true,
    },
    {
      value: "VI",
      label: "U.S. Virgin Islands",
      is_region_visible: true,
    },
    { value: "UZ", label: "Uzbekistan", is_region_visible: true },
    { value: "VU", label: "Vanuatu", is_region_visible: true },
    { value: "VA", label: "Vatican City", is_region_visible: true },
    { value: "VE", label: "Venezuela", is_region_visible: true },
    { value: "VN", label: "Vietnam", is_region_visible: true },
    {
      value: "WF",
      label: "Wallis & Futuna",
      is_region_visible: true,
    },
    { value: "EH", label: "Western Sahara", is_region_visible: true },
    { value: "YE", label: "Yemen", is_region_visible: true },
    { value: "ZM", label: "Zambia", is_region_visible: true },
    { value: "ZW", label: "Zimbabwe", is_region_visible: true },
  ],
  //国家下的州/省
  provinceList: [
    {
      title: "",
      value: "",
      label: "Please select a region, state or province.",
    },
    {
      value: "130",
      title: "A Coru\u00f1a",
      country_id: "ES",
      label: "A Coru\u00f1a",
    },
    {
      value: "104",
      title: "Aargau",
      country_id: "CH",
      label: "Aargau",
    },
    { value: "485", title: "Acre", country_id: "BR", label: "Acre" },
    {
      value: "471",
      title: "\u0100da\u017eu novads",
      country_id: "LV",
      label: "\u0100da\u017eu novads",
    },
    {
      value: "366",
      title: "Aglonas novads",
      country_id: "LV",
      label: "Aglonas novads",
    },
    {
      value: "682",
      title: "Agrigento",
      country_id: "IT",
      label: "Agrigento",
    },
    {
      value: "792",
      title: "Aguascalientes",
      country_id: "MX",
      label: "Aguascalientes",
    },
    {
      value: "339",
      title: "Ahvenanmaa",
      country_id: "FI",
      label: "Ahvenanmaa",
    },
    { value: "182", title: "Ain", country_id: "FR", label: "Ain" },
    {
      value: "183",
      title: "Aisne",
      country_id: "FR",
      label: "Aisne",
    },
    {
      value: "367",
      title: "Aizkraukles novads",
      country_id: "LV",
      label: "Aizkraukles novads",
    },
    {
      value: "368",
      title: "Aizputes novads",
      country_id: "LV",
      label: "Aizputes novads",
    },
    {
      value: "369",
      title: "Akn\u012bstes novads",
      country_id: "LV",
      label: "Akn\u012bstes novads",
    },
    {
      value: "1",
      title: "Alabama",
      country_id: "US",
      label: "Alabama",
    },
    {
      value: "486",
      title: "Alagoas",
      country_id: "BR",
      label: "Alagoas",
    },
    {
      value: "2",
      title: "Alaska",
      country_id: "US",
      label: "Alaska",
    },
    {
      value: "131",
      title: "Alava",
      country_id: "ES",
      label: "Alava",
    },
    { value: "278", title: "Alba", country_id: "RO", label: "Alba" },
    {
      value: "132",
      title: "Albacete",
      country_id: "ES",
      label: "Albacete",
    },
    {
      value: "66",
      title: "Alberta",
      country_id: "CA",
      label: "Alberta",
    },
    {
      value: "683",
      title: "Alessandria",
      country_id: "IT",
      label: "Alessandria",
    },
    {
      value: "133",
      title: "Alicante",
      country_id: "ES",
      label: "Alicante",
    },
    {
      value: "184",
      title: "Allier",
      country_id: "FR",
      label: "Allier",
    },
    {
      value: "134",
      title: "Almeria",
      country_id: "ES",
      label: "Almeria",
    },
    {
      value: "370",
      title: "Alojas novads",
      country_id: "LV",
      label: "Alojas novads",
    },
    {
      value: "185",
      title: "Alpes-de-Haute-Provence",
      country_id: "FR",
      label: "Alpes-de-Haute-Provence",
    },
    {
      value: "187",
      title: "Alpes-Maritimes",
      country_id: "FR",
      label: "Alpes-Maritimes",
    },
    {
      value: "371",
      title: "Alsungas novads",
      country_id: "LV",
      label: "Alsungas novads",
    },
    {
      value: "372",
      title: "Al\u016bksnes novads",
      country_id: "LV",
      label: "Al\u016bksnes novads",
    },
    {
      value: "475",
      title: "Alytaus Apskritis",
      country_id: "LT",
      label: "Alytaus Apskritis",
    },
    {
      value: "487",
      title: "Amap\u00e1",
      country_id: "BR",
      label: "Amap\u00e1",
    },
    {
      value: "373",
      title: "Amatas novads",
      country_id: "LV",
      label: "Amatas novads",
    },
    {
      value: "488",
      title: "Amazonas",
      country_id: "BR",
      label: "Amazonas",
    },
    {
      value: "650",
      title: "Amazonas",
      country_id: "CO",
      label: "Amazonas",
    },
    {
      value: "3",
      title: "American Samoa",
      country_id: "US",
      label: "American Samoa",
    },
    {
      value: "684",
      title: "Ancona",
      country_id: "IT",
      label: "Ancona",
    },
    {
      value: "533",
      title: "Andaman and Nicobar Islands",
      country_id: "IN",
      label: "Andaman and Nicobar Islands",
    },
    {
      value: "534",
      title: "Andhra Pradesh",
      country_id: "IN",
      label: "Andhra Pradesh",
    },
    {
      value: "616",
      title: "Anhui Sheng",
      country_id: "CN",
      label: "Anhui Sheng",
    },
    {
      value: "651",
      title: "Antioquia",
      country_id: "CO",
      label: "Antioquia",
    },
    {
      value: "577",
      title: "Antwerpen",
      country_id: "BE",
      label: "Antwerpen",
    },
    {
      value: "685",
      title: "Aosta",
      country_id: "IT",
      label: "Aosta",
    },
    {
      value: "374",
      title: "Apes novads",
      country_id: "LV",
      label: "Apes novads",
    },
    {
      value: "106",
      title: "Appenzell Ausserrhoden",
      country_id: "CH",
      label: "Appenzell Ausserrhoden",
    },
    {
      value: "105",
      title: "Appenzell Innerrhoden",
      country_id: "CH",
      label: "Appenzell Innerrhoden",
    },
    { value: "279", title: "Arad", country_id: "RO", label: "Arad" },
    {
      value: "652",
      title: "Arauca",
      country_id: "CO",
      label: "Arauca",
    },
    {
      value: "188",
      title: "Ard\u00e8che",
      country_id: "FR",
      label: "Ard\u00e8che",
    },
    {
      value: "189",
      title: "Ardennes",
      country_id: "FR",
      label: "Ardennes",
    },
    {
      value: "687",
      title: "Arezzo",
      country_id: "IT",
      label: "Arezzo",
    },
    {
      value: "280",
      title: "Arge\u015f",
      country_id: "RO",
      label: "Arge\u015f",
    },
    {
      value: "190",
      title: "Ari\u00e8ge",
      country_id: "FR",
      label: "Ari\u00e8ge",
    },
    {
      value: "4",
      title: "Arizona",
      country_id: "US",
      label: "Arizona",
    },
    {
      value: "5",
      title: "Arkansas",
      country_id: "US",
      label: "Arkansas",
    },
    {
      value: "6",
      title: "Armed Forces Africa",
      country_id: "US",
      label: "Armed Forces Africa",
    },
    {
      value: "7",
      title: "Armed Forces Americas",
      country_id: "US",
      label: "Armed Forces Americas",
    },
    {
      value: "8",
      title: "Armed Forces Canada",
      country_id: "US",
      label: "Armed Forces Canada",
    },
    {
      value: "9",
      title: "Armed Forces Europe",
      country_id: "US",
      label: "Armed Forces Europe",
    },
    {
      value: "10",
      title: "Armed Forces Middle East",
      country_id: "US",
      label: "Armed Forces Middle East",
    },
    {
      value: "11",
      title: "Armed Forces Pacific",
      country_id: "US",
      label: "Armed Forces Pacific",
    },
    {
      value: "840",
      title: "Artigas",
      country_id: "UY",
      label: "Artigas",
    },
    {
      value: "535",
      title: "Arunachal Pradesh",
      country_id: "IN",
      label: "Arunachal Pradesh",
    },
    {
      value: "688",
      title: "Ascoli-Piceno",
      country_id: "IT",
      label: "Ascoli-Piceno",
    },
    {
      value: "536",
      title: "Assam",
      country_id: "IN",
      label: "Assam",
    },
    { value: "689", title: "Asti", country_id: "IT", label: "Asti" },
    {
      value: "135",
      title: "Asturias",
      country_id: "ES",
      label: "Asturias",
    },
    {
      value: "653",
      title: "Atl\u00e1ntico",
      country_id: "CO",
      label: "Atl\u00e1ntico",
    },
    { value: "191", title: "Aube", country_id: "FR", label: "Aube" },
    {
      value: "375",
      title: "Auces novads",
      country_id: "LV",
      label: "Auces novads",
    },
    { value: "192", title: "Aude", country_id: "FR", label: "Aude" },
    {
      value: "569",
      title: "Australian Capital Territory",
      country_id: "AU",
      label: "Australian Capital Territory",
    },
    {
      value: "690",
      title: "Avellino",
      country_id: "IT",
      label: "Avellino",
    },
    {
      value: "193",
      title: "Aveyron",
      country_id: "FR",
      label: "Aveyron",
    },
    {
      value: "136",
      title: "Avila",
      country_id: "ES",
      label: "Avila",
    },
    {
      value: "376",
      title: "Bab\u012btes novads",
      country_id: "LV",
      label: "Bab\u012btes novads",
    },
    {
      value: "281",
      title: "Bac\u0103u",
      country_id: "RO",
      label: "Bac\u0103u",
    },
    {
      value: "137",
      title: "Badajoz",
      country_id: "ES",
      label: "Badajoz",
    },
    {
      value: "80",
      title: "Baden-W\u00fcrttemberg",
      country_id: "DE",
      label: "Baden-W\u00fcrttemberg",
    },
    {
      value: "489",
      title: "Bahia",
      country_id: "BR",
      label: "Bahia",
    },
    {
      value: "793",
      title: "Baja California",
      country_id: "MX",
      label: "Baja California",
    },
    {
      value: "794",
      title: "Baja California Sur",
      country_id: "MX",
      label: "Baja California Sur",
    },
    {
      value: "377",
      title: "Baldones novads",
      country_id: "LV",
      label: "Baldones novads",
    },
    {
      value: "138",
      title: "Baleares",
      country_id: "ES",
      label: "Baleares",
    },
    {
      value: "378",
      title: "Baltinavas novads",
      country_id: "LV",
      label: "Baltinavas novads",
    },
    {
      value: "379",
      title: "Balvu novads",
      country_id: "LV",
      label: "Balvu novads",
    },
    {
      value: "139",
      title: "Barcelona",
      country_id: "ES",
      label: "Barcelona",
    },
    { value: "691", title: "Bari", country_id: "IT", label: "Bari" },
    {
      value: "692",
      title: "Barletta-Andria-Trani",
      country_id: "IT",
      label: "Barletta-Andria-Trani",
    },
    {
      value: "249",
      title: "Bas-Rhin",
      country_id: "FR",
      label: "Bas-Rhin",
    },
    {
      value: "108",
      title: "Basel-Landschaft",
      country_id: "CH",
      label: "Basel-Landschaft",
    },
    {
      value: "109",
      title: "Basel-Stadt",
      country_id: "CH",
      label: "Basel-Stadt",
    },
    {
      value: "380",
      title: "Bauskas novads",
      country_id: "LV",
      label: "Bauskas novads",
    },
    {
      value: "81",
      title: "Bayern",
      country_id: "DE",
      label: "Bayern",
    },
    {
      value: "617",
      title: "Beijing Shi",
      country_id: "CN",
      label: "Beijing Shi",
    },
    {
      value: "693",
      title: "Belluno",
      country_id: "IT",
      label: "Belluno",
    },
    {
      value: "694",
      title: "Benevento",
      country_id: "IT",
      label: "Benevento",
    },
    {
      value: "695",
      title: "Bergamo",
      country_id: "IT",
      label: "Bergamo",
    },
    {
      value: "82",
      title: "Berlin",
      country_id: "DE",
      label: "Berlin",
    },
    { value: "107", title: "Bern", country_id: "CH", label: "Bern" },
    {
      value: "381",
      title: "Bever\u012bnas novads",
      country_id: "LV",
      label: "Bever\u012bnas novads",
    },
    {
      value: "696",
      title: "Biella",
      country_id: "IT",
      label: "Biella",
    },
    {
      value: "537",
      title: "Bihar",
      country_id: "IN",
      label: "Bihar",
    },
    {
      value: "282",
      title: "Bihor",
      country_id: "RO",
      label: "Bihor",
    },
    {
      value: "283",
      title: "Bistri\u0163a-N\u0103s\u0103ud",
      country_id: "RO",
      label: "Bistri\u0163a-N\u0103s\u0103ud",
    },
    {
      value: "518",
      title: "Bjelovarsko-bilogorska \u017eupanija",
      country_id: "HR",
      label: "Bjelovarsko-bilogorska \u017eupanija",
    },
    {
      value: "588",
      title: "Blagoevgrad",
      country_id: "BG",
      label: "Blagoevgrad",
    },
    {
      value: "654",
      title: "Bol\u00edvar",
      country_id: "CO",
      label: "Bol\u00edvar",
    },
    {
      value: "697",
      title: "Bologna",
      country_id: "IT",
      label: "Bologna",
    },
    {
      value: "698",
      title: "Bolzano",
      country_id: "IT",
      label: "Bolzano",
    },
    {
      value: "284",
      title: "Boto\u015fani",
      country_id: "RO",
      label: "Boto\u015fani",
    },
    {
      value: "194",
      title: "Bouches-du-Rh\u00f4ne",
      country_id: "FR",
      label: "Bouches-du-Rh\u00f4ne",
    },
    {
      value: "655",
      title: "Boyac\u00e1",
      country_id: "CO",
      label: "Boyac\u00e1",
    },
    {
      value: "578",
      title: "Brabant wallon",
      country_id: "BE",
      label: "Brabant wallon",
    },
    {
      value: "286",
      title: "Br\u0103ila",
      country_id: "RO",
      label: "Br\u0103ila",
    },
    {
      value: "83",
      title: "Brandenburg",
      country_id: "DE",
      label: "Brandenburg",
    },
    {
      value: "285",
      title: "Bra\u015fov",
      country_id: "RO",
      label: "Bra\u015fov",
    },
    {
      value: "84",
      title: "Bremen",
      country_id: "DE",
      label: "Bremen",
    },
    {
      value: "699",
      title: "Brescia",
      country_id: "IT",
      label: "Brescia",
    },
    {
      value: "700",
      title: "Brindisi",
      country_id: "IT",
      label: "Brindisi",
    },
    {
      value: "67",
      title: "British Columbia",
      country_id: "CA",
      label: "British Columbia",
    },
    {
      value: "382",
      title: "Broc\u0113nu novads",
      country_id: "LV",
      label: "Broc\u0113nu novads",
    },
    {
      value: "523",
      title: "Brodsko-posavska \u017eupanija",
      country_id: "HR",
      label: "Brodsko-posavska \u017eupanija",
    },
    {
      value: "579",
      title: "Brussels-Capital Region",
      country_id: "BE",
      label: "Brussels-Capital Region",
    },
    {
      value: "287",
      title: "Bucure\u015fti",
      country_id: "RO",
      label: "Bucure\u015fti",
    },
    {
      value: "589",
      title: "Burgas",
      country_id: "BG",
      label: "Burgas",
    },
    {
      value: "102",
      title: "Burgenland",
      country_id: "AT",
      label: "Burgenland",
    },
    {
      value: "140",
      title: "Burgos",
      country_id: "ES",
      label: "Burgos",
    },
    {
      value: "383",
      title: "Burtnieku novads",
      country_id: "LV",
      label: "Burtnieku novads",
    },
    {
      value: "288",
      title: "Buz\u0103u",
      country_id: "RO",
      label: "Buz\u0103u",
    },
    {
      value: "141",
      title: "Caceres",
      country_id: "ES",
      label: "Caceres",
    },
    {
      value: "142",
      title: "Cadiz",
      country_id: "ES",
      label: "Cadiz",
    },
    {
      value: "701",
      title: "Cagliari",
      country_id: "IT",
      label: "Cagliari",
    },
    {
      value: "290",
      title: "C\u0103l\u0103ra\u015fi",
      country_id: "RO",
      label: "C\u0103l\u0103ra\u015fi",
    },
    {
      value: "656",
      title: "Caldas",
      country_id: "CO",
      label: "Caldas",
    },
    {
      value: "12",
      title: "California",
      country_id: "US",
      label: "California",
    },
    {
      value: "702",
      title: "Caltanissetta",
      country_id: "IT",
      label: "Caltanissetta",
    },
    {
      value: "195",
      title: "Calvados",
      country_id: "FR",
      label: "Calvados",
    },
    {
      value: "795",
      title: "Campeche",
      country_id: "MX",
      label: "Campeche",
    },
    {
      value: "703",
      title: "Campobasso",
      country_id: "IT",
      label: "Campobasso",
    },
    {
      value: "841",
      title: "Canelones",
      country_id: "UY",
      label: "Canelones",
    },
    {
      value: "143",
      title: "Cantabria",
      country_id: "ES",
      label: "Cantabria",
    },
    {
      value: "196",
      title: "Cantal",
      country_id: "FR",
      label: "Cantal",
    },
    {
      value: "657",
      title: "Caquet\u00e1",
      country_id: "CO",
      label: "Caquet\u00e1",
    },
    {
      value: "289",
      title: "Cara\u015f-Severin",
      country_id: "RO",
      label: "Cara\u015f-Severin",
    },
    {
      value: "704",
      title: "Carbonia Iglesias",
      country_id: "IT",
      label: "Carbonia Iglesias",
    },
    {
      value: "384",
      title: "Carnikavas novads",
      country_id: "LV",
      label: "Carnikavas novads",
    },
    {
      value: "658",
      title: "Casanare",
      country_id: "CO",
      label: "Casanare",
    },
    {
      value: "705",
      title: "Caserta",
      country_id: "IT",
      label: "Caserta",
    },
    {
      value: "144",
      title: "Castellon",
      country_id: "ES",
      label: "Castellon",
    },
    {
      value: "706",
      title: "Catania",
      country_id: "IT",
      label: "Catania",
    },
    {
      value: "707",
      title: "Catanzaro",
      country_id: "IT",
      label: "Catanzaro",
    },
    {
      value: "659",
      title: "Cauca",
      country_id: "CO",
      label: "Cauca",
    },
    {
      value: "490",
      title: "Cear\u00e1",
      country_id: "BR",
      label: "Cear\u00e1",
    },
    {
      value: "842",
      title: "Cerro Largo",
      country_id: "UY",
      label: "Cerro Largo",
    },
    {
      value: "660",
      title: "Cesar",
      country_id: "CO",
      label: "Cesar",
    },
    {
      value: "387",
      title: "C\u0113su novads",
      country_id: "LV",
      label: "C\u0113su novads",
    },
    {
      value: "385",
      title: "Cesvaines novads",
      country_id: "LV",
      label: "Cesvaines novads",
    },
    {
      value: "145",
      title: "Ceuta",
      country_id: "ES",
      label: "Ceuta",
    },
    {
      value: "538",
      title: "Chandigarh",
      country_id: "IN",
      label: "Chandigarh",
    },
    {
      value: "197",
      title: "Charente",
      country_id: "FR",
      label: "Charente",
    },
    {
      value: "198",
      title: "Charente-Maritime",
      country_id: "FR",
      label: "Charente-Maritime",
    },
    { value: "199", title: "Cher", country_id: "FR", label: "Cher" },
    {
      value: "539",
      title: "Chhattisgarh",
      country_id: "IN",
      label: "Chhattisgarh",
    },
    {
      value: "796",
      title: "Chiapas",
      country_id: "MX",
      label: "Chiapas",
    },
    {
      value: "708",
      title: "Chieti",
      country_id: "IT",
      label: "Chieti",
    },
    {
      value: "797",
      title: "Chihuahua",
      country_id: "MX",
      label: "Chihuahua",
    },
    {
      value: "661",
      title: "Choc\u00f3",
      country_id: "CO",
      label: "Choc\u00f3",
    },
    {
      value: "618",
      title: "Chongqing Shi",
      country_id: "CN",
      label: "Chongqing Shi",
    },
    {
      value: "386",
      title: "Ciblas novads",
      country_id: "LV",
      label: "Ciblas novads",
    },
    {
      value: "798",
      title: "Ciudad de M\u00e9xico",
      country_id: "MX",
      label: "Ciudad de M\u00e9xico",
    },
    {
      value: "146",
      title: "Ciudad Real",
      country_id: "ES",
      label: "Ciudad Real",
    },
    { value: "291", title: "Cluj", country_id: "RO", label: "Cluj" },
    {
      value: "799",
      title: "Coahuila",
      country_id: "MX",
      label: "Coahuila",
    },
    {
      value: "800",
      title: "Colima",
      country_id: "MX",
      label: "Colima",
    },
    {
      value: "843",
      title: "Colonia",
      country_id: "UY",
      label: "Colonia",
    },
    {
      value: "13",
      title: "Colorado",
      country_id: "US",
      label: "Colorado",
    },
    { value: "709", title: "Como", country_id: "IT", label: "Como" },
    {
      value: "14",
      title: "Connecticut",
      country_id: "US",
      label: "Connecticut",
    },
    {
      value: "292",
      title: "Constan\u0163a",
      country_id: "RO",
      label: "Constan\u0163a",
    },
    {
      value: "662",
      title: "C\u00f3rdoba",
      country_id: "CO",
      label: "C\u00f3rdoba",
    },
    {
      value: "147",
      title: "Cordoba",
      country_id: "ES",
      label: "Cordoba",
    },
    {
      value: "200",
      title: "Corr\u00e8ze",
      country_id: "FR",
      label: "Corr\u00e8ze",
    },
    {
      value: "201",
      title: "Corse-du-Sud",
      country_id: "FR",
      label: "Corse-du-Sud",
    },
    {
      value: "710",
      title: "Cosenza",
      country_id: "IT",
      label: "Cosenza",
    },
    {
      value: "203",
      title: "C\u00f4te-d'Or",
      country_id: "FR",
      label: "C\u00f4te-d'Or",
    },
    {
      value: "204",
      title: "C\u00f4tes-d'Armor",
      country_id: "FR",
      label: "C\u00f4tes-d'Armor",
    },
    {
      value: "293",
      title: "Covasna",
      country_id: "RO",
      label: "Covasna",
    },
    {
      value: "711",
      title: "Cremona",
      country_id: "IT",
      label: "Cremona",
    },
    {
      value: "205",
      title: "Creuse",
      country_id: "FR",
      label: "Creuse",
    },
    {
      value: "712",
      title: "Crotone",
      country_id: "IT",
      label: "Crotone",
    },
    {
      value: "148",
      title: "Cuenca",
      country_id: "ES",
      label: "Cuenca",
    },
    {
      value: "663",
      title: "Cundinamarca",
      country_id: "CO",
      label: "Cundinamarca",
    },
    {
      value: "713",
      title: "Cuneo",
      country_id: "IT",
      label: "Cuneo",
    },
    {
      value: "540",
      title: "Dadra and Nagar Haveli",
      country_id: "IN",
      label: "Dadra and Nagar Haveli",
    },
    {
      value: "388",
      title: "Dagdas novads",
      country_id: "LV",
      label: "Dagdas novads",
    },
    {
      value: "541",
      title: "Daman and Diu",
      country_id: "IN",
      label: "Daman and Diu",
    },
    {
      value: "294",
      title: "D\u00e2mbovi\u0163a",
      country_id: "RO",
      label: "D\u00e2mbovi\u0163a",
    },
    {
      value: "355",
      title: "Daugavpils",
      country_id: "LV",
      label: "Daugavpils",
    },
    {
      value: "389",
      title: "Daugavpils novads",
      country_id: "LV",
      label: "Daugavpils novads",
    },
    {
      value: "15",
      title: "Delaware",
      country_id: "US",
      label: "Delaware",
    },
    {
      value: "542",
      title: "Delhi",
      country_id: "IN",
      label: "Delhi",
    },
    {
      value: "261",
      title: "Deux-S\u00e8vres",
      country_id: "FR",
      label: "Deux-S\u00e8vres",
    },
    {
      value: "16",
      title: "District of Columbia",
      country_id: "US",
      label: "District of Columbia",
    },
    {
      value: "511",
      title: "Distrito Federal",
      country_id: "BR",
      label: "Distrito Federal",
    },
    {
      value: "390",
      title: "Dobeles novads",
      country_id: "LV",
      label: "Dobeles novads",
    },
    {
      value: "595",
      title: "Dobrich",
      country_id: "BG",
      label: "Dobrich",
    },
    { value: "295", title: "Dolj", country_id: "RO", label: "Dolj" },
    {
      value: "824",
      title: "dolno\u015bl\u0105skie",
      country_id: "PL",
      label: "dolno\u015bl\u0105skie",
    },
    {
      value: "206",
      title: "Dordogne",
      country_id: "FR",
      label: "Dordogne",
    },
    {
      value: "207",
      title: "Doubs",
      country_id: "FR",
      label: "Doubs",
    },
    {
      value: "208",
      title: "Dr\u00f4me",
      country_id: "FR",
      label: "Dr\u00f4me",
    },
    {
      value: "530",
      title: "Dubrova\u010dko-neretvanska \u017eupanija",
      country_id: "HR",
      label: "Dubrova\u010dko-neretvanska \u017eupanija",
    },
    {
      value: "391",
      title: "Dundagas novads",
      country_id: "LV",
      label: "Dundagas novads",
    },
    {
      value: "801",
      title: "Durango",
      country_id: "MX",
      label: "Durango",
    },
    {
      value: "844",
      title: "Durazno",
      country_id: "UY",
      label: "Durazno",
    },
    {
      value: "392",
      title: "Durbes novads",
      country_id: "LV",
      label: "Durbes novads",
    },
    {
      value: "393",
      title: "Engures novads",
      country_id: "LV",
      label: "Engures novads",
    },
    { value: "714", title: "Enna", country_id: "IT", label: "Enna" },
    {
      value: "472",
      title: "\u0112rg\u013cu novads",
      country_id: "LV",
      label: "\u0112rg\u013cu novads",
    },
    {
      value: "491",
      title: "Esp\u00edrito Santo",
      country_id: "BR",
      label: "Esp\u00edrito Santo",
    },
    {
      value: "273",
      title: "Essonne",
      country_id: "FR",
      label: "Essonne",
    },
    {
      value: "802",
      title: "Estado de M\u00e9xico",
      country_id: "MX",
      label: "Estado de M\u00e9xico",
    },
    {
      value: "333",
      title: "Etel\u00e4-Karjala",
      country_id: "FI",
      label: "Etel\u00e4-Karjala",
    },
    {
      value: "326",
      title: "Etel\u00e4-Pohjanmaa",
      country_id: "FI",
      label: "Etel\u00e4-Pohjanmaa",
    },
    {
      value: "325",
      title: "Etel\u00e4-Savo",
      country_id: "FI",
      label: "Etel\u00e4-Savo",
    },
    { value: "209", title: "Eure", country_id: "FR", label: "Eure" },
    {
      value: "210",
      title: "Eure-et-Loir",
      country_id: "FR",
      label: "Eure-et-Loir",
    },
    {
      value: "17",
      title: "Federated States Of Micronesia",
      country_id: "US",
      label: "Federated States Of Micronesia",
    },
    {
      value: "715",
      title: "Fermo",
      country_id: "IT",
      label: "Fermo",
    },
    {
      value: "716",
      title: "Ferrara",
      country_id: "IT",
      label: "Ferrara",
    },
    {
      value: "211",
      title: "Finist\u00e8re",
      country_id: "FR",
      label: "Finist\u00e8re",
    },
    {
      value: "717",
      title: "Firenze",
      country_id: "IT",
      label: "Firenze",
    },
    {
      value: "845",
      title: "Flores",
      country_id: "UY",
      label: "Flores",
    },
    {
      value: "846",
      title: "Florida",
      country_id: "UY",
      label: "Florida",
    },
    {
      value: "18",
      title: "Florida",
      country_id: "US",
      label: "Florida",
    },
    {
      value: "718",
      title: "Foggia",
      country_id: "IT",
      label: "Foggia",
    },
    {
      value: "719",
      title: "Forli-Cesena",
      country_id: "IT",
      label: "Forli-Cesena",
    },
    {
      value: "110",
      title: "Freiburg",
      country_id: "CH",
      label: "Freiburg",
    },
    {
      value: "720",
      title: "Frosinone",
      country_id: "IT",
      label: "Frosinone",
    },
    {
      value: "619",
      title: "Fujian Sheng",
      country_id: "CN",
      label: "Fujian Sheng",
    },
    {
      value: "594",
      title: "Gabrovo",
      country_id: "BG",
      label: "Gabrovo",
    },
    {
      value: "296",
      title: "Gala\u0163i",
      country_id: "RO",
      label: "Gala\u0163i",
    },
    {
      value: "620",
      title: "Gansu Sheng",
      country_id: "CN",
      label: "Gansu Sheng",
    },
    { value: "212", title: "Gard", country_id: "FR", label: "Gard" },
    {
      value: "394",
      title: "Garkalnes novads",
      country_id: "LV",
      label: "Garkalnes novads",
    },
    { value: "111", title: "Genf", country_id: "CH", label: "Genf" },
    {
      value: "721",
      title: "Genova",
      country_id: "IT",
      label: "Genova",
    },
    {
      value: "19",
      title: "Georgia",
      country_id: "US",
      label: "Georgia",
    },
    { value: "214", title: "Gers", country_id: "FR", label: "Gers" },
    {
      value: "149",
      title: "Girona",
      country_id: "ES",
      label: "Girona",
    },
    {
      value: "215",
      title: "Gironde",
      country_id: "FR",
      label: "Gironde",
    },
    {
      value: "297",
      title: "Giurgiu",
      country_id: "RO",
      label: "Giurgiu",
    },
    {
      value: "112",
      title: "Glarus",
      country_id: "CH",
      label: "Glarus",
    },
    { value: "543", title: "Goa", country_id: "IN", label: "Goa" },
    {
      value: "492",
      title: "Goi\u00e1s",
      country_id: "BR",
      label: "Goi\u00e1s",
    },
    {
      value: "722",
      title: "Gorizia",
      country_id: "IT",
      label: "Gorizia",
    },
    { value: "298", title: "Gorj", country_id: "RO", label: "Gorj" },
    {
      value: "532",
      title: "Grad Zagreb",
      country_id: "HR",
      label: "Grad Zagreb",
    },
    {
      value: "150",
      title: "Granada",
      country_id: "ES",
      label: "Granada",
    },
    {
      value: "113",
      title: "Graub\u00fcnden",
      country_id: "CH",
      label: "Graub\u00fcnden",
    },
    {
      value: "395",
      title: "Grobi\u0146as novads",
      country_id: "LV",
      label: "Grobi\u0146as novads",
    },
    {
      value: "723",
      title: "Grosseto",
      country_id: "IT",
      label: "Grosseto",
    },
    {
      value: "151",
      title: "Guadalajara",
      country_id: "ES",
      label: "Guadalajara",
    },
    {
      value: "664",
      title: "Guain\u00eda",
      country_id: "CO",
      label: "Guain\u00eda",
    },
    { value: "20", title: "Guam", country_id: "US", label: "Guam" },
    {
      value: "803",
      title: "Guanajuato",
      country_id: "MX",
      label: "Guanajuato",
    },
    {
      value: "621",
      title: "Guangdong Sheng",
      country_id: "CN",
      label: "Guangdong Sheng",
    },
    {
      value: "622",
      title: "Guangxi Zhuangzu Zizhiqu",
      country_id: "CN",
      label: "Guangxi Zhuangzu Zizhiqu",
    },
    {
      value: "665",
      title: "Guaviare",
      country_id: "CO",
      label: "Guaviare",
    },
    {
      value: "804",
      title: "Guerrero",
      country_id: "MX",
      label: "Guerrero",
    },
    {
      value: "152",
      title: "Guipuzcoa",
      country_id: "ES",
      label: "Guipuzcoa",
    },
    {
      value: "623",
      title: "Guizhou Sheng",
      country_id: "CN",
      label: "Guizhou Sheng",
    },
    {
      value: "544",
      title: "Gujarat",
      country_id: "IN",
      label: "Gujarat",
    },
    {
      value: "396",
      title: "Gulbenes novads",
      country_id: "LV",
      label: "Gulbenes novads",
    },
    {
      value: "624",
      title: "Hainan Sheng",
      country_id: "CN",
      label: "Hainan Sheng",
    },
    {
      value: "580",
      title: "Hainaut",
      country_id: "BE",
      label: "Hainaut",
    },
    {
      value: "85",
      title: "Hamburg",
      country_id: "DE",
      label: "Hamburg",
    },
    {
      value: "299",
      title: "Harghita",
      country_id: "RO",
      label: "Harghita",
    },
    {
      value: "340",
      title: "Harjumaa",
      country_id: "EE",
      label: "Harjumaa",
    },
    {
      value: "545",
      title: "Haryana",
      country_id: "IN",
      label: "Haryana",
    },
    {
      value: "613",
      title: "Haskovo",
      country_id: "BG",
      label: "Haskovo",
    },
    {
      value: "250",
      title: "Haut-Rhin",
      country_id: "FR",
      label: "Haut-Rhin",
    },
    {
      value: "202",
      title: "Haute-Corse",
      country_id: "FR",
      label: "Haute-Corse",
    },
    {
      value: "213",
      title: "Haute-Garonne",
      country_id: "FR",
      label: "Haute-Garonne",
    },
    {
      value: "225",
      title: "Haute-Loire",
      country_id: "FR",
      label: "Haute-Loire",
    },
    {
      value: "234",
      title: "Haute-Marne",
      country_id: "FR",
      label: "Haute-Marne",
    },
    {
      value: "252",
      title: "Haute-Sa\u00f4ne",
      country_id: "FR",
      label: "Haute-Sa\u00f4ne",
    },
    {
      value: "256",
      title: "Haute-Savoie",
      country_id: "FR",
      label: "Haute-Savoie",
    },
    {
      value: "269",
      title: "Haute-Vienne",
      country_id: "FR",
      label: "Haute-Vienne",
    },
    {
      value: "186",
      title: "Hautes-Alpes",
      country_id: "FR",
      label: "Hautes-Alpes",
    },
    {
      value: "247",
      title: "Hautes-Pyr\u00e9n\u00e9es",
      country_id: "FR",
      label: "Hautes-Pyr\u00e9n\u00e9es",
    },
    {
      value: "274",
      title: "Hauts-de-Seine",
      country_id: "FR",
      label: "Hauts-de-Seine",
    },
    {
      value: "21",
      title: "Hawaii",
      country_id: "US",
      label: "Hawaii",
    },
    {
      value: "625",
      title: "Hebei Sheng",
      country_id: "CN",
      label: "Hebei Sheng",
    },
    {
      value: "626",
      title: "Heilongjiang Sheng",
      country_id: "CN",
      label: "Heilongjiang Sheng",
    },
    {
      value: "627",
      title: "Henan Sheng",
      country_id: "CN",
      label: "Henan Sheng",
    },
    {
      value: "216",
      title: "H\u00e9rault",
      country_id: "FR",
      label: "H\u00e9rault",
    },
    {
      value: "86",
      title: "Hessen",
      country_id: "DE",
      label: "Hessen",
    },
    {
      value: "805",
      title: "Hidalgo",
      country_id: "MX",
      label: "Hidalgo",
    },
    {
      value: "341",
      title: "Hiiumaa",
      country_id: "EE",
      label: "Hiiumaa",
    },
    {
      value: "546",
      title: "Himachal Pradesh",
      country_id: "IN",
      label: "Himachal Pradesh",
    },
    {
      value: "628",
      title: "Hong Kong SAR",
      country_id: "CN",
      label: "Hong Kong SAR",
    },
    {
      value: "629",
      title: "Hubei Sheng",
      country_id: "CN",
      label: "Hubei Sheng",
    },
    {
      value: "153",
      title: "Huelva",
      country_id: "ES",
      label: "Huelva",
    },
    {
      value: "154",
      title: "Huesca",
      country_id: "ES",
      label: "Huesca",
    },
    {
      value: "666",
      title: "Huila",
      country_id: "CO",
      label: "Huila",
    },
    {
      value: "630",
      title: "Hunan Sheng",
      country_id: "CN",
      label: "Hunan Sheng",
    },
    {
      value: "300",
      title: "Hunedoara",
      country_id: "RO",
      label: "Hunedoara",
    },
    {
      value: "301",
      title: "Ialomi\u0163a",
      country_id: "RO",
      label: "Ialomi\u0163a",
    },
    {
      value: "302",
      title: "Ia\u015fi",
      country_id: "RO",
      label: "Ia\u015fi",
    },
    {
      value: "342",
      title: "Ida-Virumaa",
      country_id: "EE",
      label: "Ida-Virumaa",
    },
    { value: "22", title: "Idaho", country_id: "US", label: "Idaho" },
    {
      value: "397",
      title: "Iecavas novads",
      country_id: "LV",
      label: "Iecavas novads",
    },
    {
      value: "398",
      title: "Ik\u0161\u0137iles novads",
      country_id: "LV",
      label: "Ik\u0161\u0137iles novads",
    },
    {
      value: "303",
      title: "Ilfov",
      country_id: "RO",
      label: "Ilfov",
    },
    {
      value: "217",
      title: "Ille-et-Vilaine",
      country_id: "FR",
      label: "Ille-et-Vilaine",
    },
    {
      value: "23",
      title: "Illinois",
      country_id: "US",
      label: "Illinois",
    },
    {
      value: "399",
      title: "Il\u016bkstes novads",
      country_id: "LV",
      label: "Il\u016bkstes novads",
    },
    {
      value: "724",
      title: "Imperia",
      country_id: "IT",
      label: "Imperia",
    },
    {
      value: "400",
      title: "In\u010dukalna novads",
      country_id: "LV",
      label: "In\u010dukalna novads",
    },
    {
      value: "24",
      title: "Indiana",
      country_id: "US",
      label: "Indiana",
    },
    {
      value: "218",
      title: "Indre",
      country_id: "FR",
      label: "Indre",
    },
    {
      value: "219",
      title: "Indre-et-Loire",
      country_id: "FR",
      label: "Indre-et-Loire",
    },
    { value: "25", title: "Iowa", country_id: "US", label: "Iowa" },
    {
      value: "220",
      title: "Is\u00e8re",
      country_id: "FR",
      label: "Is\u00e8re",
    },
    {
      value: "725",
      title: "Isernia",
      country_id: "IT",
      label: "Isernia",
    },
    {
      value: "529",
      title: "Istarska \u017eupanija",
      country_id: "HR",
      label: "Istarska \u017eupanija",
    },
    {
      value: "337",
      title: "It\u00e4-Uusimaa",
      country_id: "FI",
      label: "It\u00e4-Uusimaa",
    },
    { value: "155", title: "Jaen", country_id: "ES", label: "Jaen" },
    {
      value: "806",
      title: "Jalisco",
      country_id: "MX",
      label: "Jalisco",
    },
    {
      value: "547",
      title: "Jammu and Kashmir",
      country_id: "IN",
      label: "Jammu and Kashmir",
    },
    {
      value: "344",
      title: "J\u00e4rvamaa",
      country_id: "EE",
      label: "J\u00e4rvamaa",
    },
    {
      value: "401",
      title: "Jaunjelgavas novads",
      country_id: "LV",
      label: "Jaunjelgavas novads",
    },
    {
      value: "402",
      title: "Jaunpiebalgas novads",
      country_id: "LV",
      label: "Jaunpiebalgas novads",
    },
    {
      value: "403",
      title: "Jaunpils novads",
      country_id: "LV",
      label: "Jaunpils novads",
    },
    {
      value: "357",
      title: "J\u0113kabpils",
      country_id: "LV",
      label: "J\u0113kabpils",
    },
    {
      value: "405",
      title: "J\u0113kabpils novads",
      country_id: "LV",
      label: "J\u0113kabpils novads",
    },
    {
      value: "356",
      title: "Jelgava",
      country_id: "LV",
      label: "Jelgava",
    },
    {
      value: "404",
      title: "Jelgavas novads",
      country_id: "LV",
      label: "Jelgavas novads",
    },
    {
      value: "548",
      title: "Jharkhand",
      country_id: "IN",
      label: "Jharkhand",
    },
    {
      value: "631",
      title: "Jiangsu Sheng",
      country_id: "CN",
      label: "Jiangsu Sheng",
    },
    {
      value: "632",
      title: "Jiangxi Sheng",
      country_id: "CN",
      label: "Jiangxi Sheng",
    },
    {
      value: "633",
      title: "Jilin Sheng",
      country_id: "CN",
      label: "Jilin Sheng",
    },
    {
      value: "343",
      title: "J\u00f5gevamaa",
      country_id: "EE",
      label: "J\u00f5gevamaa",
    },
    { value: "114", title: "Jura", country_id: "CH", label: "Jura" },
    { value: "221", title: "Jura", country_id: "FR", label: "Jura" },
    {
      value: "358",
      title: "J\u016brmala",
      country_id: "LV",
      label: "J\u016brmala",
    },
    {
      value: "322",
      title: "Kainuu",
      country_id: "FI",
      label: "Kainuu",
    },
    {
      value: "406",
      title: "Kandavas novads",
      country_id: "LV",
      label: "Kandavas novads",
    },
    {
      value: "26",
      title: "Kansas",
      country_id: "US",
      label: "Kansas",
    },
    {
      value: "335",
      title: "Kanta-H\u00e4me",
      country_id: "FI",
      label: "Kanta-H\u00e4me",
    },
    {
      value: "596",
      title: "Kardzhali",
      country_id: "BG",
      label: "Kardzhali",
    },
    {
      value: "515",
      title: "Karlova\u010dka \u017eupanija",
      country_id: "HR",
      label: "Karlova\u010dka \u017eupanija",
    },
    {
      value: "549",
      title: "Karnataka",
      country_id: "IN",
      label: "Karnataka",
    },
    {
      value: "99",
      title: "K\u00e4rnten",
      country_id: "AT",
      label: "K\u00e4rnten",
    },
    {
      value: "412",
      title: "K\u0101rsavas novads",
      country_id: "LV",
      label: "K\u0101rsavas novads",
    },
    {
      value: "476",
      title: "Kauno Apskritis",
      country_id: "LT",
      label: "Kauno Apskritis",
    },
    {
      value: "473",
      title: "\u0136eguma novads",
      country_id: "LV",
      label: "\u0136eguma novads",
    },
    {
      value: "474",
      title: "\u0136ekavas novads",
      country_id: "LV",
      label: "\u0136ekavas novads",
    },
    {
      value: "27",
      title: "Kentucky",
      country_id: "US",
      label: "Kentucky",
    },
    {
      value: "550",
      title: "Kerala",
      country_id: "IN",
      label: "Kerala",
    },
    {
      value: "330",
      title: "Keski-Pohjanmaa",
      country_id: "FI",
      label: "Keski-Pohjanmaa",
    },
    {
      value: "331",
      title: "Keski-Suomi",
      country_id: "FI",
      label: "Keski-Suomi",
    },
    {
      value: "477",
      title: "Klaip\u0117dos Apskritis",
      country_id: "LT",
      label: "Klaip\u0117dos Apskritis",
    },
    {
      value: "407",
      title: "Kokneses novads",
      country_id: "LV",
      label: "Kokneses novads",
    },
    {
      value: "517",
      title: "Koprivni\u010dko-kri\u017eeva\u010dka \u017eupanija",
      country_id: "HR",
      label: "Koprivni\u010dko-kri\u017eeva\u010dka \u017eupanija",
    },
    {
      value: "513",
      title: "Krapinsko-zagorska \u017eupanija",
      country_id: "HR",
      label: "Krapinsko-zagorska \u017eupanija",
    },
    {
      value: "410",
      title: "Kr\u0101slavas novads",
      country_id: "LV",
      label: "Kr\u0101slavas novads",
    },
    {
      value: "408",
      title: "Krimuldas novads",
      country_id: "LV",
      label: "Krimuldas novads",
    },
    {
      value: "409",
      title: "Krustpils novads",
      country_id: "LV",
      label: "Krustpils novads",
    },
    {
      value: "825",
      title: "kujawsko-pomorskie",
      country_id: "PL",
      label: "kujawsko-pomorskie",
    },
    {
      value: "411",
      title: "Kuld\u012bgas novads",
      country_id: "LV",
      label: "Kuld\u012bgas novads",
    },
    {
      value: "338",
      title: "Kymenlaakso",
      country_id: "FI",
      label: "Kymenlaakso",
    },
    {
      value: "597",
      title: "Kyustendil",
      country_id: "BG",
      label: "Kyustendil",
    },
    {
      value: "686",
      title: "L'Aquila",
      country_id: "IT",
      label: "L'Aquila",
    },
    {
      value: "667",
      title: "La Guajira",
      country_id: "CO",
      label: "La Guajira",
    },
    {
      value: "156",
      title: "La Rioja",
      country_id: "ES",
      label: "La Rioja",
    },
    {
      value: "726",
      title: "La-Spezia",
      country_id: "IT",
      label: "La-Spezia",
    },
    {
      value: "346",
      title: "L\u00e4\u00e4ne-Virumaa",
      country_id: "EE",
      label: "L\u00e4\u00e4ne-Virumaa",
    },
    {
      value: "345",
      title: "L\u00e4\u00e4nemaa",
      country_id: "EE",
      label: "L\u00e4\u00e4nemaa",
    },
    {
      value: "551",
      title: "Lakshadweep",
      country_id: "IN",
      label: "Lakshadweep",
    },
    {
      value: "222",
      title: "Landes",
      country_id: "FR",
      label: "Landes",
    },
    {
      value: "320",
      title: "Lappi",
      country_id: "FI",
      label: "Lappi",
    },
    {
      value: "157",
      title: "Las Palmas",
      country_id: "ES",
      label: "Las Palmas",
    },
    {
      value: "727",
      title: "Latina",
      country_id: "IT",
      label: "Latina",
    },
    {
      value: "847",
      title: "Lavalleja",
      country_id: "UY",
      label: "Lavalleja",
    },
    {
      value: "728",
      title: "Lecce",
      country_id: "IT",
      label: "Lecce",
    },
    {
      value: "729",
      title: "Lecco",
      country_id: "IT",
      label: "Lecco",
    },
    { value: "158", title: "Leon", country_id: "ES", label: "Leon" },
    {
      value: "634",
      title: "Liaoning Sheng",
      country_id: "CN",
      label: "Liaoning Sheng",
    },
    {
      value: "520",
      title: "Li\u010dko-senjska \u017eupanija",
      country_id: "HR",
      label: "Li\u010dko-senjska \u017eupanija",
    },
    {
      value: "582",
      title: "Li\u00e8ge",
      country_id: "BE",
      label: "Li\u00e8ge",
    },
    {
      value: "413",
      title: "Lielv\u0101rdes novads",
      country_id: "LV",
      label: "Lielv\u0101rdes novads",
    },
    {
      value: "359",
      title: "Liep\u0101ja",
      country_id: "LV",
      label: "Liep\u0101ja",
    },
    {
      value: "360",
      title: "Liep\u0101jas novads",
      country_id: "LV",
      label: "Liep\u0101jas novads",
    },
    {
      value: "417",
      title: "L\u012bgatnes novads",
      country_id: "LV",
      label: "L\u012bgatnes novads",
    },
    {
      value: "414",
      title: "Limba\u017eu novads",
      country_id: "LV",
      label: "Limba\u017eu novads",
    },
    {
      value: "581",
      title: "Limburg",
      country_id: "BE",
      label: "Limburg",
    },
    {
      value: "418",
      title: "L\u012bv\u0101nu novads",
      country_id: "LV",
      label: "L\u012bv\u0101nu novads",
    },
    {
      value: "730",
      title: "Livorno",
      country_id: "IT",
      label: "Livorno",
    },
    {
      value: "159",
      title: "Lleida",
      country_id: "ES",
      label: "Lleida",
    },
    { value: "731", title: "Lodi", country_id: "IT", label: "Lodi" },
    {
      value: "223",
      title: "Loir-et-Cher",
      country_id: "FR",
      label: "Loir-et-Cher",
    },
    {
      value: "224",
      title: "Loire",
      country_id: "FR",
      label: "Loire",
    },
    {
      value: "226",
      title: "Loire-Atlantique",
      country_id: "FR",
      label: "Loire-Atlantique",
    },
    {
      value: "227",
      title: "Loiret",
      country_id: "FR",
      label: "Loiret",
    },
    { value: "228", title: "Lot", country_id: "FR", label: "Lot" },
    {
      value: "229",
      title: "Lot-et-Garonne",
      country_id: "FR",
      label: "Lot-et-Garonne",
    },
    {
      value: "28",
      title: "Louisiana",
      country_id: "US",
      label: "Louisiana",
    },
    {
      value: "598",
      title: "Lovech",
      country_id: "BG",
      label: "Lovech",
    },
    {
      value: "230",
      title: "Loz\u00e8re",
      country_id: "FR",
      label: "Loz\u00e8re",
    },
    {
      value: "415",
      title: "Lub\u0101nas novads",
      country_id: "LV",
      label: "Lub\u0101nas novads",
    },
    {
      value: "826",
      title: "lubelskie",
      country_id: "PL",
      label: "lubelskie",
    },
    {
      value: "827",
      title: "lubuskie",
      country_id: "PL",
      label: "lubuskie",
    },
    {
      value: "732",
      title: "Lucca",
      country_id: "IT",
      label: "Lucca",
    },
    {
      value: "416",
      title: "Ludzas novads",
      country_id: "LV",
      label: "Ludzas novads",
    },
    { value: "160", title: "Lugo", country_id: "ES", label: "Lugo" },
    {
      value: "583",
      title: "Luxembourg",
      country_id: "BE",
      label: "Luxembourg",
    },
    {
      value: "115",
      title: "Luzern",
      country_id: "CH",
      label: "Luzern",
    },
    {
      value: "635",
      title: "Macao SAR",
      country_id: "CN",
      label: "Macao SAR",
    },
    {
      value: "733",
      title: "Macerata",
      country_id: "IT",
      label: "Macerata",
    },
    {
      value: "552",
      title: "Madhya Pradesh",
      country_id: "IN",
      label: "Madhya Pradesh",
    },
    {
      value: "419",
      title: "Madonas novads",
      country_id: "LV",
      label: "Madonas novads",
    },
    {
      value: "161",
      title: "Madrid",
      country_id: "ES",
      label: "Madrid",
    },
    {
      value: "668",
      title: "Magdalena",
      country_id: "CO",
      label: "Magdalena",
    },
    {
      value: "553",
      title: "Maharashtra",
      country_id: "IN",
      label: "Maharashtra",
    },
    { value: "29", title: "Maine", country_id: "US", label: "Maine" },
    {
      value: "231",
      title: "Maine-et-Loire",
      country_id: "FR",
      label: "Maine-et-Loire",
    },
    {
      value: "162",
      title: "Malaga",
      country_id: "ES",
      label: "Malaga",
    },
    {
      value: "848",
      title: "Maldonado",
      country_id: "UY",
      label: "Maldonado",
    },
    {
      value: "421",
      title: "M\u0101lpils novads",
      country_id: "LV",
      label: "M\u0101lpils novads",
    },
    {
      value: "232",
      title: "Manche",
      country_id: "FR",
      label: "Manche",
    },
    {
      value: "554",
      title: "Manipur",
      country_id: "IN",
      label: "Manipur",
    },
    {
      value: "68",
      title: "Manitoba",
      country_id: "CA",
      label: "Manitoba",
    },
    {
      value: "734",
      title: "Mantova",
      country_id: "IT",
      label: "Mantova",
    },
    {
      value: "304",
      title: "Maramure\u015f",
      country_id: "RO",
      label: "Maramure\u015f",
    },
    {
      value: "493",
      title: "Maranh\u00e3o",
      country_id: "BR",
      label: "Maranh\u00e3o",
    },
    {
      value: "478",
      title: "Marijampol\u0117s Apskritis",
      country_id: "LT",
      label: "Marijampol\u0117s Apskritis",
    },
    {
      value: "233",
      title: "Marne",
      country_id: "FR",
      label: "Marne",
    },
    {
      value: "30",
      title: "Marshall Islands",
      country_id: "US",
      label: "Marshall Islands",
    },
    {
      value: "422",
      title: "M\u0101rupes novads",
      country_id: "LV",
      label: "M\u0101rupes novads",
    },
    {
      value: "31",
      title: "Maryland",
      country_id: "US",
      label: "Maryland",
    },
    {
      value: "735",
      title: "Massa-Carrara",
      country_id: "IT",
      label: "Massa-Carrara",
    },
    {
      value: "32",
      title: "Massachusetts",
      country_id: "US",
      label: "Massachusetts",
    },
    {
      value: "736",
      title: "Matera",
      country_id: "IT",
      label: "Matera",
    },
    {
      value: "494",
      title: "Mato Grosso",
      country_id: "BR",
      label: "Mato Grosso",
    },
    {
      value: "495",
      title: "Mato Grosso do Sul",
      country_id: "BR",
      label: "Mato Grosso do Sul",
    },
    {
      value: "235",
      title: "Mayenne",
      country_id: "FR",
      label: "Mayenne",
    },
    {
      value: "830",
      title: "mazowieckie",
      country_id: "PL",
      label: "mazowieckie",
    },
    {
      value: "420",
      title: "Mazsalacas novads",
      country_id: "LV",
      label: "Mazsalacas novads",
    },
    {
      value: "829",
      title: "ma\u0142opolskie",
      country_id: "PL",
      label: "ma\u0142opolskie",
    },
    {
      value: "87",
      title: "Mecklenburg-Vorpommern",
      country_id: "DE",
      label: "Mecklenburg-Vorpommern",
    },
    {
      value: "737",
      title: "Medio Campidano",
      country_id: "IT",
      label: "Medio Campidano",
    },
    {
      value: "555",
      title: "Meghalaya",
      country_id: "IN",
      label: "Meghalaya",
    },
    {
      value: "305",
      title: "Mehedin\u0163i",
      country_id: "RO",
      label: "Mehedin\u0163i",
    },
    {
      value: "163",
      title: "Melilla",
      country_id: "ES",
      label: "Melilla",
    },
    {
      value: "738",
      title: "Messina",
      country_id: "IT",
      label: "Messina",
    },
    { value: "669", title: "Meta", country_id: "CO", label: "Meta" },
    {
      value: "236",
      title: "Meurthe-et-Moselle",
      country_id: "FR",
      label: "Meurthe-et-Moselle",
    },
    {
      value: "237",
      title: "Meuse",
      country_id: "FR",
      label: "Meuse",
    },
    {
      value: "531",
      title: "Me\u0111imurska \u017eupanija",
      country_id: "HR",
      label: "Me\u0111imurska \u017eupanija",
    },
    {
      value: "33",
      title: "Michigan",
      country_id: "US",
      label: "Michigan",
    },
    {
      value: "807",
      title: "Michoac\u00e1n",
      country_id: "MX",
      label: "Michoac\u00e1n",
    },
    {
      value: "739",
      title: "Milano",
      country_id: "IT",
      label: "Milano",
    },
    {
      value: "496",
      title: "Minas Gerais",
      country_id: "BR",
      label: "Minas Gerais",
    },
    {
      value: "34",
      title: "Minnesota",
      country_id: "US",
      label: "Minnesota",
    },
    {
      value: "35",
      title: "Mississippi",
      country_id: "US",
      label: "Mississippi",
    },
    {
      value: "36",
      title: "Missouri",
      country_id: "US",
      label: "Missouri",
    },
    {
      value: "556",
      title: "Mizoram",
      country_id: "IN",
      label: "Mizoram",
    },
    {
      value: "740",
      title: "Modena",
      country_id: "IT",
      label: "Modena",
    },
    {
      value: "599",
      title: "Montana",
      country_id: "BG",
      label: "Montana",
    },
    {
      value: "37",
      title: "Montana",
      country_id: "US",
      label: "Montana",
    },
    {
      value: "849",
      title: "Montevideo",
      country_id: "UY",
      label: "Montevideo",
    },
    {
      value: "741",
      title: "Monza-Brianza",
      country_id: "IT",
      label: "Monza-Brianza",
    },
    {
      value: "238",
      title: "Morbihan",
      country_id: "FR",
      label: "Morbihan",
    },
    {
      value: "808",
      title: "Morelos",
      country_id: "MX",
      label: "Morelos",
    },
    {
      value: "239",
      title: "Moselle",
      country_id: "FR",
      label: "Moselle",
    },
    {
      value: "164",
      title: "Murcia",
      country_id: "ES",
      label: "Murcia",
    },
    {
      value: "306",
      title: "Mure\u015f",
      country_id: "RO",
      label: "Mure\u015f",
    },
    {
      value: "557",
      title: "Nagaland",
      country_id: "IN",
      label: "Nagaland",
    },
    {
      value: "584",
      title: "Namur",
      country_id: "BE",
      label: "Namur",
    },
    {
      value: "742",
      title: "Napoli",
      country_id: "IT",
      label: "Napoli",
    },
    {
      value: "670",
      title: "Nari\u00f1o",
      country_id: "CO",
      label: "Nari\u00f1o",
    },
    {
      value: "423",
      title: "Nauk\u0161\u0113nu novads",
      country_id: "LV",
      label: "Nauk\u0161\u0113nu novads",
    },
    {
      value: "165",
      title: "Navarra",
      country_id: "ES",
      label: "Navarra",
    },
    {
      value: "809",
      title: "Nayarit",
      country_id: "MX",
      label: "Nayarit",
    },
    {
      value: "307",
      title: "Neam\u0163",
      country_id: "RO",
      label: "Neam\u0163",
    },
    {
      value: "38",
      title: "Nebraska",
      country_id: "US",
      label: "Nebraska",
    },
    {
      value: "636",
      title: "Nei Mongol Zizhiqu",
      country_id: "CN",
      label: "Nei Mongol Zizhiqu",
    },
    {
      value: "424",
      title: "Neretas novads",
      country_id: "LV",
      label: "Neretas novads",
    },
    {
      value: "116",
      title: "Neuenburg",
      country_id: "CH",
      label: "Neuenburg",
    },
    {
      value: "39",
      title: "Nevada",
      country_id: "US",
      label: "Nevada",
    },
    {
      value: "70",
      title: "New Brunswick",
      country_id: "CA",
      label: "New Brunswick",
    },
    {
      value: "40",
      title: "New Hampshire",
      country_id: "US",
      label: "New Hampshire",
    },
    {
      value: "41",
      title: "New Jersey",
      country_id: "US",
      label: "New Jersey",
    },
    {
      value: "42",
      title: "New Mexico",
      country_id: "US",
      label: "New Mexico",
    },
    {
      value: "570",
      title: "New South Wales",
      country_id: "AU",
      label: "New South Wales",
    },
    {
      value: "43",
      title: "New York",
      country_id: "US",
      label: "New York",
    },
    {
      value: "69",
      title: "Newfoundland and Labrador",
      country_id: "CA",
      label: "Newfoundland and Labrador",
    },
    {
      value: "425",
      title: "N\u012bcas novads",
      country_id: "LV",
      label: "N\u012bcas novads",
    },
    {
      value: "117",
      title: "Nidwalden",
      country_id: "CH",
      label: "Nidwalden",
    },
    {
      value: "96",
      title: "Nieder\u00f6sterreich",
      country_id: "AT",
      label: "Nieder\u00f6sterreich",
    },
    {
      value: "79",
      title: "Niedersachsen",
      country_id: "DE",
      label: "Niedersachsen",
    },
    {
      value: "240",
      title: "Ni\u00e8vre",
      country_id: "FR",
      label: "Ni\u00e8vre",
    },
    {
      value: "637",
      title: "Ningxia Huizi Zizhiqu",
      country_id: "CN",
      label: "Ningxia Huizi Zizhiqu",
    },
    { value: "241", title: "Nord", country_id: "FR", label: "Nord" },
    {
      value: "88",
      title: "Nordrhein-Westfalen",
      country_id: "DE",
      label: "Nordrhein-Westfalen",
    },
    {
      value: "671",
      title: "Norte de Santander",
      country_id: "CO",
      label: "Norte de Santander",
    },
    {
      value: "44",
      title: "North Carolina",
      country_id: "US",
      label: "North Carolina",
    },
    {
      value: "45",
      title: "North Dakota",
      country_id: "US",
      label: "North Dakota",
    },
    {
      value: "46",
      title: "Northern Mariana Islands",
      country_id: "US",
      label: "Northern Mariana Islands",
    },
    {
      value: "576",
      title: "Northern Territory",
      country_id: "AU",
      label: "Northern Territory",
    },
    {
      value: "72",
      title: "Northwest Territories",
      country_id: "CA",
      label: "Northwest Territories",
    },
    {
      value: "71",
      title: "Nova Scotia",
      country_id: "CA",
      label: "Nova Scotia",
    },
    {
      value: "743",
      title: "Novara",
      country_id: "IT",
      label: "Novara",
    },
    {
      value: "810",
      title: "Nuevo Le\u00f3n",
      country_id: "MX",
      label: "Nuevo Le\u00f3n",
    },
    {
      value: "73",
      title: "Nunavut",
      country_id: "CA",
      label: "Nunavut",
    },
    {
      value: "744",
      title: "Nuoro",
      country_id: "IT",
      label: "Nuoro",
    },
    {
      value: "811",
      title: "Oaxaca",
      country_id: "MX",
      label: "Oaxaca",
    },
    {
      value: "97",
      title: "Ober\u00f6sterreich",
      country_id: "AT",
      label: "Ober\u00f6sterreich",
    },
    {
      value: "118",
      title: "Obwalden",
      country_id: "CH",
      label: "Obwalden",
    },
    {
      value: "558",
      title: "Odisha",
      country_id: "IN",
      label: "Odisha",
    },
    {
      value: "745",
      title: "Ogliastra",
      country_id: "IT",
      label: "Ogliastra",
    },
    {
      value: "426",
      title: "Ogres novads",
      country_id: "LV",
      label: "Ogres novads",
    },
    { value: "47", title: "Ohio", country_id: "US", label: "Ohio" },
    { value: "242", title: "Oise", country_id: "FR", label: "Oise" },
    {
      value: "48",
      title: "Oklahoma",
      country_id: "US",
      label: "Oklahoma",
    },
    {
      value: "427",
      title: "Olaines novads",
      country_id: "LV",
      label: "Olaines novads",
    },
    {
      value: "746",
      title: "Olbia Tempio",
      country_id: "IT",
      label: "Olbia Tempio",
    },
    { value: "308", title: "Olt", country_id: "RO", label: "Olt" },
    {
      value: "74",
      title: "Ontario",
      country_id: "CA",
      label: "Ontario",
    },
    {
      value: "585",
      title: "Oost-Vlaanderen",
      country_id: "BE",
      label: "Oost-Vlaanderen",
    },
    {
      value: "831",
      title: "opolskie",
      country_id: "PL",
      label: "opolskie",
    },
    {
      value: "49",
      title: "Oregon",
      country_id: "US",
      label: "Oregon",
    },
    {
      value: "747",
      title: "Oristano",
      country_id: "IT",
      label: "Oristano",
    },
    { value: "243", title: "Orne", country_id: "FR", label: "Orne" },
    {
      value: "525",
      title: "Osje\u010dko-baranjska \u017eupanija",
      country_id: "HR",
      label: "Osje\u010dko-baranjska \u017eupanija",
    },
    {
      value: "166",
      title: "Ourense",
      country_id: "ES",
      label: "Ourense",
    },
    {
      value: "428",
      title: "Ozolnieku novads",
      country_id: "LV",
      label: "Ozolnieku novads",
    },
    {
      value: "748",
      title: "Padova",
      country_id: "IT",
      label: "Padova",
    },
    {
      value: "334",
      title: "P\u00e4ij\u00e4t-H\u00e4me",
      country_id: "FI",
      label: "P\u00e4ij\u00e4t-H\u00e4me",
    },
    { value: "50", title: "Palau", country_id: "US", label: "Palau" },
    {
      value: "167",
      title: "Palencia",
      country_id: "ES",
      label: "Palencia",
    },
    {
      value: "749",
      title: "Palermo",
      country_id: "IT",
      label: "Palermo",
    },
    {
      value: "479",
      title: "Panev\u0117\u017eio Apskritis",
      country_id: "LT",
      label: "Panev\u0117\u017eio Apskritis",
    },
    {
      value: "497",
      title: "Par\u00e1",
      country_id: "BR",
      label: "Par\u00e1",
    },
    {
      value: "498",
      title: "Para\u00edba",
      country_id: "BR",
      label: "Para\u00edba",
    },
    {
      value: "499",
      title: "Paran\u00e1",
      country_id: "BR",
      label: "Paran\u00e1",
    },
    {
      value: "432",
      title: "P\u0101rgaujas novads",
      country_id: "LV",
      label: "P\u0101rgaujas novads",
    },
    {
      value: "257",
      title: "Paris",
      country_id: "FR",
      label: "Paris",
    },
    {
      value: "750",
      title: "Parma",
      country_id: "IT",
      label: "Parma",
    },
    {
      value: "348",
      title: "P\u00e4rnumaa",
      country_id: "EE",
      label: "P\u00e4rnumaa",
    },
    {
      value: "244",
      title: "Pas-de-Calais",
      country_id: "FR",
      label: "Pas-de-Calais",
    },
    {
      value: "751",
      title: "Pavia",
      country_id: "IT",
      label: "Pavia",
    },
    {
      value: "433",
      title: "P\u0101vilostas novads",
      country_id: "LV",
      label: "P\u0101vilostas novads",
    },
    {
      value: "850",
      title: "Paysandu",
      country_id: "UY",
      label: "Paysandu",
    },
    {
      value: "600",
      title: "Pazardzhik",
      country_id: "BG",
      label: "Pazardzhik",
    },
    {
      value: "51",
      title: "Pennsylvania",
      country_id: "US",
      label: "Pennsylvania",
    },
    {
      value: "500",
      title: "Pernambuco",
      country_id: "BR",
      label: "Pernambuco",
    },
    {
      value: "601",
      title: "Pernik",
      country_id: "BG",
      label: "Pernik",
    },
    {
      value: "752",
      title: "Perugia",
      country_id: "IT",
      label: "Perugia",
    },
    {
      value: "753",
      title: "Pesaro-Urbino",
      country_id: "IT",
      label: "Pesaro-Urbino",
    },
    {
      value: "754",
      title: "Pescara",
      country_id: "IT",
      label: "Pescara",
    },
    {
      value: "755",
      title: "Piacenza",
      country_id: "IT",
      label: "Piacenza",
    },
    {
      value: "501",
      title: "Piau\u00ed",
      country_id: "BR",
      label: "Piau\u00ed",
    },
    {
      value: "328",
      title: "Pirkanmaa",
      country_id: "FI",
      label: "Pirkanmaa",
    },
    { value: "756", title: "Pisa", country_id: "IT", label: "Pisa" },
    {
      value: "757",
      title: "Pistoia",
      country_id: "IT",
      label: "Pistoia",
    },
    {
      value: "434",
      title: "P\u013cavi\u0146u novads",
      country_id: "LV",
      label: "P\u013cavi\u0146u novads",
    },
    {
      value: "602",
      title: "Pleven",
      country_id: "BG",
      label: "Pleven",
    },
    {
      value: "603",
      title: "Plovdiv",
      country_id: "BG",
      label: "Plovdiv",
    },
    {
      value: "832",
      title: "podkarpackie",
      country_id: "PL",
      label: "podkarpackie",
    },
    {
      value: "833",
      title: "podlaskie",
      country_id: "PL",
      label: "podlaskie",
    },
    {
      value: "327",
      title: "Pohjanmaa",
      country_id: "FI",
      label: "Pohjanmaa",
    },
    {
      value: "323",
      title: "Pohjois-Karjala",
      country_id: "FI",
      label: "Pohjois-Karjala",
    },
    {
      value: "321",
      title: "Pohjois-Pohjanmaa",
      country_id: "FI",
      label: "Pohjois-Pohjanmaa",
    },
    {
      value: "324",
      title: "Pohjois-Savo",
      country_id: "FI",
      label: "Pohjois-Savo",
    },
    {
      value: "347",
      title: "P\u00f5lvamaa",
      country_id: "EE",
      label: "P\u00f5lvamaa",
    },
    {
      value: "834",
      title: "pomorskie",
      country_id: "PL",
      label: "pomorskie",
    },
    {
      value: "168",
      title: "Pontevedra",
      country_id: "ES",
      label: "Pontevedra",
    },
    {
      value: "758",
      title: "Pordenone",
      country_id: "IT",
      label: "Pordenone",
    },
    {
      value: "759",
      title: "Potenza",
      country_id: "IT",
      label: "Potenza",
    },
    {
      value: "522",
      title: "Po\u017ee\u0161ko-slavonska \u017eupanija",
      country_id: "HR",
      label: "Po\u017ee\u0161ko-slavonska \u017eupanija",
    },
    {
      value: "309",
      title: "Prahova",
      country_id: "RO",
      label: "Prahova",
    },
    {
      value: "760",
      title: "Prato",
      country_id: "IT",
      label: "Prato",
    },
    {
      value: "429",
      title: "Prei\u013cu novads",
      country_id: "LV",
      label: "Prei\u013cu novads",
    },
    {
      value: "430",
      title: "Priekules novads",
      country_id: "LV",
      label: "Priekules novads",
    },
    {
      value: "431",
      title: "Prieku\u013cu novads",
      country_id: "LV",
      label: "Prieku\u013cu novads",
    },
    {
      value: "519",
      title: "Primorsko-goranska \u017eupanija",
      country_id: "HR",
      label: "Primorsko-goranska \u017eupanija",
    },
    {
      value: "75",
      title: "Prince Edward Island",
      country_id: "CA",
      label: "Prince Edward Island",
    },
    {
      value: "559",
      title: "Puducherry",
      country_id: "IN",
      label: "Puducherry",
    },
    {
      value: "812",
      title: "Puebla",
      country_id: "MX",
      label: "Puebla",
    },
    {
      value: "560",
      title: "Punjab",
      country_id: "IN",
      label: "Punjab",
    },
    {
      value: "672",
      title: "Putumayo",
      country_id: "CO",
      label: "Putumayo",
    },
    {
      value: "245",
      title: "Puy-de-D\u00f4me",
      country_id: "FR",
      label: "Puy-de-D\u00f4me",
    },
    {
      value: "246",
      title: "Pyr\u00e9n\u00e9es-Atlantiques",
      country_id: "FR",
      label: "Pyr\u00e9n\u00e9es-Atlantiques",
    },
    {
      value: "248",
      title: "Pyr\u00e9n\u00e9es-Orientales",
      country_id: "FR",
      label: "Pyr\u00e9n\u00e9es-Orientales",
    },
    {
      value: "638",
      title: "Qinghai Sheng",
      country_id: "CN",
      label: "Qinghai Sheng",
    },
    {
      value: "76",
      title: "Quebec",
      country_id: "CA",
      label: "Quebec",
    },
    {
      value: "572",
      title: "Queensland",
      country_id: "AU",
      label: "Queensland",
    },
    {
      value: "813",
      title: "Quer\u00e9taro",
      country_id: "MX",
      label: "Quer\u00e9taro",
    },
    {
      value: "673",
      title: "Quind\u00edo",
      country_id: "CO",
      label: "Quind\u00edo",
    },
    {
      value: "814",
      title: "Quintana Roo",
      country_id: "MX",
      label: "Quintana Roo",
    },
    {
      value: "761",
      title: "Ragusa",
      country_id: "IT",
      label: "Ragusa",
    },
    {
      value: "561",
      title: "Rajasthan",
      country_id: "IN",
      label: "Rajasthan",
    },
    {
      value: "349",
      title: "Raplamaa",
      country_id: "EE",
      label: "Raplamaa",
    },
    {
      value: "435",
      title: "Raunas novads",
      country_id: "LV",
      label: "Raunas novads",
    },
    {
      value: "762",
      title: "Ravenna",
      country_id: "IT",
      label: "Ravenna",
    },
    {
      value: "604",
      title: "Razgrad",
      country_id: "BG",
      label: "Razgrad",
    },
    {
      value: "763",
      title: "Reggio-Calabria",
      country_id: "IT",
      label: "Reggio-Calabria",
    },
    {
      value: "764",
      title: "Reggio-Emilia",
      country_id: "IT",
      label: "Reggio-Emilia",
    },
    {
      value: "361",
      title: "R\u0113zekne",
      country_id: "LV",
      label: "R\u0113zekne",
    },
    {
      value: "442",
      title: "R\u0113zeknes novads",
      country_id: "LV",
      label: "R\u0113zeknes novads",
    },
    {
      value: "89",
      title: "Rheinland-Pfalz",
      country_id: "DE",
      label: "Rheinland-Pfalz",
    },
    {
      value: "53",
      title: "Rhode Island",
      country_id: "US",
      label: "Rhode Island",
    },
    {
      value: "251",
      title: "Rh\u00f4ne",
      country_id: "FR",
      label: "Rh\u00f4ne",
    },
    {
      value: "436",
      title: "Riebi\u0146u novads",
      country_id: "LV",
      label: "Riebi\u0146u novads",
    },
    {
      value: "765",
      title: "Rieti",
      country_id: "IT",
      label: "Rieti",
    },
    {
      value: "362",
      title: "R\u012bga",
      country_id: "LV",
      label: "R\u012bga",
    },
    {
      value: "363",
      title: "R\u012bgas novads",
      country_id: "LV",
      label: "R\u012bgas novads",
    },
    {
      value: "766",
      title: "Rimini",
      country_id: "IT",
      label: "Rimini",
    },
    {
      value: "502",
      title: "Rio de Janeiro",
      country_id: "BR",
      label: "Rio de Janeiro",
    },
    {
      value: "503",
      title: "Rio Grande do Norte",
      country_id: "BR",
      label: "Rio Grande do Norte",
    },
    {
      value: "504",
      title: "Rio Grande do Sul",
      country_id: "BR",
      label: "Rio Grande do Sul",
    },
    {
      value: "851",
      title: "R\u00edo Negro",
      country_id: "UY",
      label: "R\u00edo Negro",
    },
    {
      value: "674",
      title: "Risaralda",
      country_id: "CO",
      label: "Risaralda",
    },
    {
      value: "852",
      title: "Rivera",
      country_id: "UY",
      label: "Rivera",
    },
    {
      value: "853",
      title: "Rocha",
      country_id: "UY",
      label: "Rocha",
    },
    {
      value: "437",
      title: "Rojas novads",
      country_id: "LV",
      label: "Rojas novads",
    },
    { value: "767", title: "Roma", country_id: "IT", label: "Roma" },
    {
      value: "505",
      title: "Rond\u00f4nia",
      country_id: "BR",
      label: "Rond\u00f4nia",
    },
    {
      value: "438",
      title: "Ropa\u017eu novads",
      country_id: "LV",
      label: "Ropa\u017eu novads",
    },
    {
      value: "506",
      title: "Roraima",
      country_id: "BR",
      label: "Roraima",
    },
    {
      value: "768",
      title: "Rovigo",
      country_id: "IT",
      label: "Rovigo",
    },
    {
      value: "439",
      title: "Rucavas novads",
      country_id: "LV",
      label: "Rucavas novads",
    },
    {
      value: "440",
      title: "Rug\u0101ju novads",
      country_id: "LV",
      label: "Rug\u0101ju novads",
    },
    {
      value: "443",
      title: "R\u016bjienas novads",
      country_id: "LV",
      label: "R\u016bjienas novads",
    },
    {
      value: "441",
      title: "Rund\u0101les novads",
      country_id: "LV",
      label: "Rund\u0101les novads",
    },
    { value: "605", title: "Ruse", country_id: "BG", label: "Ruse" },
    {
      value: "350",
      title: "Saaremaa",
      country_id: "EE",
      label: "Saaremaa",
    },
    {
      value: "90",
      title: "Saarland",
      country_id: "DE",
      label: "Saarland",
    },
    {
      value: "91",
      title: "Sachsen",
      country_id: "DE",
      label: "Sachsen",
    },
    {
      value: "92",
      title: "Sachsen-Anhalt",
      country_id: "DE",
      label: "Sachsen-Anhalt",
    },
    {
      value: "444",
      title: "Salacgr\u012bvas novads",
      country_id: "LV",
      label: "Salacgr\u012bvas novads",
    },
    {
      value: "311",
      title: "S\u0103laj",
      country_id: "RO",
      label: "S\u0103laj",
    },
    {
      value: "169",
      title: "Salamanca",
      country_id: "ES",
      label: "Salamanca",
    },
    {
      value: "445",
      title: "Salas novads",
      country_id: "LV",
      label: "Salas novads",
    },
    {
      value: "446",
      title: "Salaspils novads",
      country_id: "LV",
      label: "Salaspils novads",
    },
    {
      value: "447",
      title: "Saldus novads",
      country_id: "LV",
      label: "Saldus novads",
    },
    {
      value: "769",
      title: "Salerno",
      country_id: "IT",
      label: "Salerno",
    },
    {
      value: "854",
      title: "Salto",
      country_id: "UY",
      label: "Salto",
    },
    {
      value: "98",
      title: "Salzburg",
      country_id: "AT",
      label: "Salzburg",
    },
    {
      value: "675",
      title: "San Andr\u00e9s y Providencia",
      country_id: "CO",
      label: "San Andr\u00e9s y Providencia",
    },
    {
      value: "855",
      title: "San Jos\u00e9",
      country_id: "UY",
      label: "San Jos\u00e9",
    },
    {
      value: "815",
      title: "San Luis Potos\u00ed",
      country_id: "MX",
      label: "San Luis Potos\u00ed",
    },
    {
      value: "507",
      title: "Santa Catarina",
      country_id: "BR",
      label: "Santa Catarina",
    },
    {
      value: "170",
      title: "Santa Cruz de Tenerife",
      country_id: "ES",
      label: "Santa Cruz de Tenerife",
    },
    {
      value: "676",
      title: "Santander",
      country_id: "CO",
      label: "Santander",
    },
    {
      value: "508",
      title: "S\u00e3o Paulo",
      country_id: "BR",
      label: "S\u00e3o Paulo",
    },
    {
      value: "253",
      title: "Sa\u00f4ne-et-Loire",
      country_id: "FR",
      label: "Sa\u00f4ne-et-Loire",
    },
    {
      value: "254",
      title: "Sarthe",
      country_id: "FR",
      label: "Sarthe",
    },
    {
      value: "77",
      title: "Saskatchewan",
      country_id: "CA",
      label: "Saskatchewan",
    },
    {
      value: "770",
      title: "Sassari",
      country_id: "IT",
      label: "Sassari",
    },
    {
      value: "329",
      title: "Satakunta",
      country_id: "FI",
      label: "Satakunta",
    },
    {
      value: "310",
      title: "Satu-Mare",
      country_id: "RO",
      label: "Satu-Mare",
    },
    {
      value: "448",
      title: "Saulkrastu novads",
      country_id: "LV",
      label: "Saulkrastu novads",
    },
    {
      value: "255",
      title: "Savoie",
      country_id: "FR",
      label: "Savoie",
    },
    {
      value: "771",
      title: "Savona",
      country_id: "IT",
      label: "Savona",
    },
    {
      value: "120",
      title: "Schaffhausen",
      country_id: "CH",
      label: "Schaffhausen",
    },
    {
      value: "93",
      title: "Schleswig-Holstein",
      country_id: "DE",
      label: "Schleswig-Holstein",
    },
    {
      value: "122",
      title: "Schwyz",
      country_id: "CH",
      label: "Schwyz",
    },
    {
      value: "171",
      title: "Segovia",
      country_id: "ES",
      label: "Segovia",
    },
    {
      value: "259",
      title: "Seine-et-Marne",
      country_id: "FR",
      label: "Seine-et-Marne",
    },
    {
      value: "258",
      title: "Seine-Maritime",
      country_id: "FR",
      label: "Seine-Maritime",
    },
    {
      value: "275",
      title: "Seine-Saint-Denis",
      country_id: "FR",
      label: "Seine-Saint-Denis",
    },
    {
      value: "455",
      title: "S\u0113jas novads",
      country_id: "LV",
      label: "S\u0113jas novads",
    },
    {
      value: "509",
      title: "Sergipe",
      country_id: "BR",
      label: "Sergipe",
    },
    {
      value: "172",
      title: "Sevilla",
      country_id: "ES",
      label: "Sevilla",
    },
    {
      value: "639",
      title: "Shaanxi Sheng",
      country_id: "CN",
      label: "Shaanxi Sheng",
    },
    {
      value: "640",
      title: "Shandong Sheng",
      country_id: "CN",
      label: "Shandong Sheng",
    },
    {
      value: "641",
      title: "Shanghai Shi",
      country_id: "CN",
      label: "Shanghai Shi",
    },
    {
      value: "642",
      title: "Shanxi Sheng",
      country_id: "CN",
      label: "Shanxi Sheng",
    },
    {
      value: "614",
      title: "Shumen",
      country_id: "BG",
      label: "Shumen",
    },
    {
      value: "480",
      title: "\u0160iauli\u0173 Apskritis",
      country_id: "LT",
      label: "\u0160iauli\u0173 Apskritis",
    },
    {
      value: "526",
      title: "\u0160ibensko-kninska \u017eupanija",
      country_id: "HR",
      label: "\u0160ibensko-kninska \u017eupanija",
    },
    {
      value: "312",
      title: "Sibiu",
      country_id: "RO",
      label: "Sibiu",
    },
    {
      value: "643",
      title: "Sichuan Sheng",
      country_id: "CN",
      label: "Sichuan Sheng",
    },
    {
      value: "772",
      title: "Siena",
      country_id: "IT",
      label: "Siena",
    },
    {
      value: "449",
      title: "Siguldas novads",
      country_id: "LV",
      label: "Siguldas novads",
    },
    {
      value: "562",
      title: "Sikkim",
      country_id: "IN",
      label: "Sikkim",
    },
    {
      value: "606",
      title: "Silistra",
      country_id: "BG",
      label: "Silistra",
    },
    {
      value: "816",
      title: "Sinaloa",
      country_id: "MX",
      label: "Sinaloa",
    },
    {
      value: "773",
      title: "Siracusa",
      country_id: "IT",
      label: "Siracusa",
    },
    {
      value: "514",
      title: "Sisa\u010dko-moslava\u010dka \u017eupanija",
      country_id: "HR",
      label: "Sisa\u010dko-moslava\u010dka \u017eupanija",
    },
    {
      value: "451",
      title: "Skr\u012bveru novads",
      country_id: "LV",
      label: "Skr\u012bveru novads",
    },
    {
      value: "450",
      title: "Skrundas novads",
      country_id: "LV",
      label: "Skrundas novads",
    },
    {
      value: "835",
      title: "\u015bl\u0105skie",
      country_id: "PL",
      label: "\u015bl\u0105skie",
    },
    {
      value: "607",
      title: "Sliven",
      country_id: "BG",
      label: "Sliven",
    },
    {
      value: "452",
      title: "Smiltenes novads",
      country_id: "LV",
      label: "Smiltenes novads",
    },
    {
      value: "608",
      title: "Smolyan",
      country_id: "BG",
      label: "Smolyan",
    },
    {
      value: "609",
      title: "Sofia City",
      country_id: "BG",
      label: "Sofia City",
    },
    {
      value: "610",
      title: "Sofia Province",
      country_id: "BG",
      label: "Sofia Province",
    },
    {
      value: "121",
      title: "Solothurn",
      country_id: "CH",
      label: "Solothurn",
    },
    {
      value: "262",
      title: "Somme",
      country_id: "FR",
      label: "Somme",
    },
    {
      value: "774",
      title: "Sondrio",
      country_id: "IT",
      label: "Sondrio",
    },
    {
      value: "817",
      title: "Sonora",
      country_id: "MX",
      label: "Sonora",
    },
    {
      value: "173",
      title: "Soria",
      country_id: "ES",
      label: "Soria",
    },
    {
      value: "856",
      title: "Soriano",
      country_id: "UY",
      label: "Soriano",
    },
    {
      value: "573",
      title: "South Australia",
      country_id: "AU",
      label: "South Australia",
    },
    {
      value: "54",
      title: "South Carolina",
      country_id: "US",
      label: "South Carolina",
    },
    {
      value: "55",
      title: "South Dakota",
      country_id: "US",
      label: "South Dakota",
    },
    {
      value: "528",
      title: "Splitsko-dalmatinska \u017eupanija",
      country_id: "HR",
      label: "Splitsko-dalmatinska \u017eupanija",
    },
    {
      value: "119",
      title: "St. Gallen",
      country_id: "CH",
      label: "St. Gallen",
    },
    {
      value: "611",
      title: "Stara Zagora",
      country_id: "BG",
      label: "Stara Zagora",
    },
    {
      value: "100",
      title: "Steiermark",
      country_id: "AT",
      label: "Steiermark",
    },
    {
      value: "453",
      title: "Stopi\u0146u novads",
      country_id: "LV",
      label: "Stopi\u0146u novads",
    },
    {
      value: "454",
      title: "Stren\u010du novads",
      country_id: "LV",
      label: "Stren\u010du novads",
    },
    {
      value: "313",
      title: "Suceava",
      country_id: "RO",
      label: "Suceava",
    },
    {
      value: "677",
      title: "Sucre",
      country_id: "CO",
      label: "Sucre",
    },
    {
      value: "836",
      title: "\u015bwi\u0119tokrzyskie",
      country_id: "PL",
      label: "\u015bwi\u0119tokrzyskie",
    },
    {
      value: "818",
      title: "Tabasco",
      country_id: "MX",
      label: "Tabasco",
    },
    {
      value: "857",
      title: "Tacuaremb\u00f3",
      country_id: "UY",
      label: "Tacuaremb\u00f3",
    },
    {
      value: "644",
      title: "Taiwan Sheng",
      country_id: "CN",
      label: "Taiwan Sheng",
    },
    {
      value: "456",
      title: "Talsu novads",
      country_id: "LV",
      label: "Talsu novads",
    },
    {
      value: "819",
      title: "Tamaulipas",
      country_id: "MX",
      label: "Tamaulipas",
    },
    {
      value: "563",
      title: "Tamil Nadu",
      country_id: "IN",
      label: "Tamil Nadu",
    },
    {
      value: "775",
      title: "Taranto",
      country_id: "IT",
      label: "Taranto",
    },
    {
      value: "612",
      title: "Targovishte",
      country_id: "BG",
      label: "Targovishte",
    },
    { value: "263", title: "Tarn", country_id: "FR", label: "Tarn" },
    {
      value: "264",
      title: "Tarn-et-Garonne",
      country_id: "FR",
      label: "Tarn-et-Garonne",
    },
    {
      value: "174",
      title: "Tarragona",
      country_id: "ES",
      label: "Tarragona",
    },
    {
      value: "351",
      title: "Tartumaa",
      country_id: "EE",
      label: "Tartumaa",
    },
    {
      value: "574",
      title: "Tasmania",
      country_id: "AU",
      label: "Tasmania",
    },
    {
      value: "481",
      title: "Taurag\u0117s Apskritis",
      country_id: "LT",
      label: "Taurag\u0117s Apskritis",
    },
    {
      value: "564",
      title: "Telangana",
      country_id: "IN",
      label: "Telangana",
    },
    {
      value: "314",
      title: "Teleorman",
      country_id: "RO",
      label: "Teleorman",
    },
    {
      value: "482",
      title: "Tel\u0161i\u0173 Apskritis",
      country_id: "LT",
      label: "Tel\u0161i\u0173 Apskritis",
    },
    {
      value: "56",
      title: "Tennessee",
      country_id: "US",
      label: "Tennessee",
    },
    {
      value: "776",
      title: "Teramo",
      country_id: "IT",
      label: "Teramo",
    },
    {
      value: "777",
      title: "Terni",
      country_id: "IT",
      label: "Terni",
    },
    {
      value: "272",
      title: "Territoire-de-Belfort",
      country_id: "FR",
      label: "Territoire-de-Belfort",
    },
    {
      value: "175",
      title: "Teruel",
      country_id: "ES",
      label: "Teruel",
    },
    {
      value: "458",
      title: "T\u0113rvetes novads",
      country_id: "LV",
      label: "T\u0113rvetes novads",
    },
    {
      value: "124",
      title: "Tessin",
      country_id: "CH",
      label: "Tessin",
    },
    { value: "57", title: "Texas", country_id: "US", label: "Texas" },
    {
      value: "123",
      title: "Thurgau",
      country_id: "CH",
      label: "Thurgau",
    },
    {
      value: "94",
      title: "Th\u00fcringen",
      country_id: "DE",
      label: "Th\u00fcringen",
    },
    {
      value: "645",
      title: "Tianjin Shi",
      country_id: "CN",
      label: "Tianjin Shi",
    },
    {
      value: "315",
      title: "Timi\u015f",
      country_id: "RO",
      label: "Timi\u015f",
    },
    {
      value: "101",
      title: "Tirol",
      country_id: "AT",
      label: "Tirol",
    },
    {
      value: "820",
      title: "Tlaxcala",
      country_id: "MX",
      label: "Tlaxcala",
    },
    {
      value: "510",
      title: "Tocantins",
      country_id: "BR",
      label: "Tocantins",
    },
    {
      value: "176",
      title: "Toledo",
      country_id: "ES",
      label: "Toledo",
    },
    {
      value: "678",
      title: "Tolima",
      country_id: "CO",
      label: "Tolima",
    },
    {
      value: "778",
      title: "Torino",
      country_id: "IT",
      label: "Torino",
    },
    {
      value: "779",
      title: "Trapani",
      country_id: "IT",
      label: "Trapani",
    },
    {
      value: "858",
      title: "Treinta y Tres",
      country_id: "UY",
      label: "Treinta y Tres",
    },
    {
      value: "780",
      title: "Trento",
      country_id: "IT",
      label: "Trento",
    },
    {
      value: "781",
      title: "Treviso",
      country_id: "IT",
      label: "Treviso",
    },
    {
      value: "782",
      title: "Trieste",
      country_id: "IT",
      label: "Trieste",
    },
    {
      value: "565",
      title: "Tripura",
      country_id: "IN",
      label: "Tripura",
    },
    {
      value: "457",
      title: "Tukuma novads",
      country_id: "LV",
      label: "Tukuma novads",
    },
    {
      value: "316",
      title: "Tulcea",
      country_id: "RO",
      label: "Tulcea",
    },
    {
      value: "783",
      title: "Udine",
      country_id: "IT",
      label: "Udine",
    },
    { value: "125", title: "Uri", country_id: "CH", label: "Uri" },
    { value: "58", title: "Utah", country_id: "US", label: "Utah" },
    {
      value: "483",
      title: "Utenos Apskritis",
      country_id: "LT",
      label: "Utenos Apskritis",
    },
    {
      value: "566",
      title: "Uttar Pradesh",
      country_id: "IN",
      label: "Uttar Pradesh",
    },
    {
      value: "567",
      title: "Uttarakhand",
      country_id: "IN",
      label: "Uttarakhand",
    },
    {
      value: "336",
      title: "Uusimaa",
      country_id: "FI",
      label: "Uusimaa",
    },
    {
      value: "459",
      title: "Vai\u0146odes novads",
      country_id: "LV",
      label: "Vai\u0146odes novads",
    },
    {
      value: "277",
      title: "Val-d'Oise",
      country_id: "FR",
      label: "Val-d'Oise",
    },
    {
      value: "276",
      title: "Val-de-Marne",
      country_id: "FR",
      label: "Val-de-Marne",
    },
    {
      value: "318",
      title: "V\u00e2lcea",
      country_id: "RO",
      label: "V\u00e2lcea",
    },
    {
      value: "177",
      title: "Valencia",
      country_id: "ES",
      label: "Valencia",
    },
    {
      value: "352",
      title: "Valgamaa",
      country_id: "EE",
      label: "Valgamaa",
    },
    {
      value: "460",
      title: "Valkas novads",
      country_id: "LV",
      label: "Valkas novads",
    },
    {
      value: "178",
      title: "Valladolid",
      country_id: "ES",
      label: "Valladolid",
    },
    {
      value: "679",
      title: "Valle del Cauca",
      country_id: "CO",
      label: "Valle del Cauca",
    },
    {
      value: "364",
      title: "Valmiera",
      country_id: "LV",
      label: "Valmiera",
    },
    {
      value: "461",
      title: "Valmieras novads",
      country_id: "LV",
      label: "Valmieras novads",
    },
    { value: "265", title: "Var", country_id: "FR", label: "Var" },
    {
      value: "462",
      title: "Varak\u013c\u0101nu novads",
      country_id: "LV",
      label: "Varak\u013c\u0101nu novads",
    },
    {
      value: "516",
      title: "Vara\u017edinska \u017eupanija",
      country_id: "HR",
      label: "Vara\u017edinska \u017eupanija",
    },
    {
      value: "784",
      title: "Varese",
      country_id: "IT",
      label: "Varese",
    },
    {
      value: "469",
      title: "V\u0101rkavas novads",
      country_id: "LV",
      label: "V\u0101rkavas novads",
    },
    {
      value: "590",
      title: "Varna",
      country_id: "BG",
      label: "Varna",
    },
    {
      value: "332",
      title: "Varsinais-Suomi",
      country_id: "FI",
      label: "Varsinais-Suomi",
    },
    {
      value: "317",
      title: "Vaslui",
      country_id: "RO",
      label: "Vaslui",
    },
    {
      value: "266",
      title: "Vaucluse",
      country_id: "FR",
      label: "Vaucluse",
    },
    {
      value: "680",
      title: "Vaup\u00e9s",
      country_id: "CO",
      label: "Vaup\u00e9s",
    },
    {
      value: "463",
      title: "Vecpiebalgas novads",
      country_id: "LV",
      label: "Vecpiebalgas novads",
    },
    {
      value: "464",
      title: "Vecumnieku novads",
      country_id: "LV",
      label: "Vecumnieku novads",
    },
    {
      value: "591",
      title: "Veliko Tarnovo",
      country_id: "BG",
      label: "Veliko Tarnovo",
    },
    {
      value: "267",
      title: "Vend\u00e9e",
      country_id: "FR",
      label: "Vend\u00e9e",
    },
    {
      value: "785",
      title: "Venezia",
      country_id: "IT",
      label: "Venezia",
    },
    {
      value: "365",
      title: "Ventspils",
      country_id: "LV",
      label: "Ventspils",
    },
    {
      value: "465",
      title: "Ventspils novads",
      country_id: "LV",
      label: "Ventspils novads",
    },
    {
      value: "821",
      title: "Veracruz",
      country_id: "MX",
      label: "Veracruz",
    },
    {
      value: "786",
      title: "Verbania",
      country_id: "IT",
      label: "Verbania",
    },
    {
      value: "787",
      title: "Vercelli",
      country_id: "IT",
      label: "Vercelli",
    },
    {
      value: "59",
      title: "Vermont",
      country_id: "US",
      label: "Vermont",
    },
    {
      value: "788",
      title: "Verona",
      country_id: "IT",
      label: "Verona",
    },
    {
      value: "789",
      title: "Vibo-Valentia",
      country_id: "IT",
      label: "Vibo-Valentia",
    },
    {
      value: "790",
      title: "Vicenza",
      country_id: "IT",
      label: "Vicenza",
    },
    {
      value: "681",
      title: "Vichada",
      country_id: "CO",
      label: "Vichada",
    },
    {
      value: "571",
      title: "Victoria",
      country_id: "AU",
      label: "Victoria",
    },
    {
      value: "592",
      title: "Vidin",
      country_id: "BG",
      label: "Vidin",
    },
    {
      value: "268",
      title: "Vienne",
      country_id: "FR",
      label: "Vienne",
    },
    {
      value: "466",
      title: "Vies\u012btes novads",
      country_id: "LV",
      label: "Vies\u012btes novads",
    },
    {
      value: "467",
      title: "Vi\u013cakas novads",
      country_id: "LV",
      label: "Vi\u013cakas novads",
    },
    {
      value: "468",
      title: "Vi\u013c\u0101nu novads",
      country_id: "LV",
      label: "Vi\u013c\u0101nu novads",
    },
    {
      value: "353",
      title: "Viljandimaa",
      country_id: "EE",
      label: "Viljandimaa",
    },
    {
      value: "484",
      title: "Vilniaus Apskritis",
      country_id: "LT",
      label: "Vilniaus Apskritis",
    },
    {
      value: "60",
      title: "Virgin Islands",
      country_id: "US",
      label: "Virgin Islands",
    },
    {
      value: "61",
      title: "Virginia",
      country_id: "US",
      label: "Virginia",
    },
    {
      value: "521",
      title: "Viroviti\u010dko-podravska \u017eupanija",
      country_id: "HR",
      label: "Viroviti\u010dko-podravska \u017eupanija",
    },
    {
      value: "791",
      title: "Viterbo",
      country_id: "IT",
      label: "Viterbo",
    },
    {
      value: "179",
      title: "Vizcaya",
      country_id: "ES",
      label: "Vizcaya",
    },
    {
      value: "586",
      title: "Vlaams-Brabant",
      country_id: "BE",
      label: "Vlaams-Brabant",
    },
    {
      value: "103",
      title: "Vorarlberg",
      country_id: "AT",
      label: "Vorarlberg",
    },
    {
      value: "354",
      title: "V\u00f5rumaa",
      country_id: "EE",
      label: "V\u00f5rumaa",
    },
    {
      value: "270",
      title: "Vosges",
      country_id: "FR",
      label: "Vosges",
    },
    {
      value: "319",
      title: "Vrancea",
      country_id: "RO",
      label: "Vrancea",
    },
    {
      value: "593",
      title: "Vratsa",
      country_id: "BG",
      label: "Vratsa",
    },
    {
      value: "527",
      title: "Vukovarsko-srijemska \u017eupanija",
      country_id: "HR",
      label: "Vukovarsko-srijemska \u017eupanija",
    },
    {
      value: "126",
      title: "Waadt",
      country_id: "CH",
      label: "Waadt",
    },
    {
      value: "127",
      title: "Wallis",
      country_id: "CH",
      label: "Wallis",
    },
    {
      value: "837",
      title: "warmi\u0144sko-mazurskie",
      country_id: "PL",
      label: "warmi\u0144sko-mazurskie",
    },
    {
      value: "62",
      title: "Washington",
      country_id: "US",
      label: "Washington",
    },
    {
      value: "568",
      title: "West Bengal",
      country_id: "IN",
      label: "West Bengal",
    },
    {
      value: "63",
      title: "West Virginia",
      country_id: "US",
      label: "West Virginia",
    },
    {
      value: "587",
      title: "West-Vlaanderen",
      country_id: "BE",
      label: "West-Vlaanderen",
    },
    {
      value: "575",
      title: "Western Australia",
      country_id: "AU",
      label: "Western Australia",
    },
    {
      value: "838",
      title: "wielkopolskie",
      country_id: "PL",
      label: "wielkopolskie",
    },
    { value: "95", title: "Wien", country_id: "AT", label: "Wien" },
    {
      value: "64",
      title: "Wisconsin",
      country_id: "US",
      label: "Wisconsin",
    },
    {
      value: "65",
      title: "Wyoming",
      country_id: "US",
      label: "Wyoming",
    },
    {
      value: "646",
      title: "Xinjiang Uygur Zizhiqu",
      country_id: "CN",
      label: "Xinjiang Uygur Zizhiqu",
    },
    {
      value: "647",
      title: "Xizang Zizhiqu",
      country_id: "CN",
      label: "Xizang Zizhiqu",
    },
    {
      value: "615",
      title: "Yambol",
      country_id: "BG",
      label: "Yambol",
    },
    {
      value: "271",
      title: "Yonne",
      country_id: "FR",
      label: "Yonne",
    },
    {
      value: "822",
      title: "Yucat\u00e1n",
      country_id: "MX",
      label: "Yucat\u00e1n",
    },
    {
      value: "78",
      title: "Yukon Territory",
      country_id: "CA",
      label: "Yukon Territory",
    },
    {
      value: "648",
      title: "Yunnan Sheng",
      country_id: "CN",
      label: "Yunnan Sheng",
    },
    {
      value: "260",
      title: "Yvelines",
      country_id: "FR",
      label: "Yvelines",
    },
    {
      value: "823",
      title: "Zacatecas",
      country_id: "MX",
      label: "Zacatecas",
    },
    {
      value: "839",
      title: "zachodniopomorskie",
      country_id: "PL",
      label: "zachodniopomorskie",
    },
    {
      value: "524",
      title: "Zadarska \u017eupanija",
      country_id: "HR",
      label: "Zadarska \u017eupanija",
    },
    {
      value: "512",
      title: "Zagreba\u010dka \u017eupanija",
      country_id: "HR",
      label: "Zagreba\u010dka \u017eupanija",
    },
    {
      value: "180",
      title: "Zamora",
      country_id: "ES",
      label: "Zamora",
    },
    {
      value: "181",
      title: "Zaragoza",
      country_id: "ES",
      label: "Zaragoza",
    },
    {
      value: "649",
      title: "Zhejiang Sheng",
      country_id: "CN",
      label: "Zhejiang Sheng",
    },
    {
      value: "470",
      title: "Zilupes novads",
      country_id: "LV",
      label: "Zilupes novads",
    },
    { value: "128", title: "Zug", country_id: "CH", label: "Zug" },
    {
      value: "129",
      title: "Z\u00fcrich",
      country_id: "CH",
      label: "Z\u00fcrich",
    },
    {
      value: "828",
      title: "\u0142\u00f3dzkie",
      country_id: "PL",
      label: "\u0142\u00f3dzkie",
    },
  ],
};




export default obj